/*
================================================================ 
         Copyright (c) 2018-2021 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/
import { connect } from "react-redux";
import actionTypes from "../../../store/actions";
import { withTranslation } from "react-i18next";
import React, { useEffect, useState, useRef } from "react";

//dialog imports
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "../../../component/button";
import ComponentForm from "./componentForm";
import ConfigurationResource from "./configurationResource";
import jp, { value } from "jsonpath";
import Loader from "../../../component/loader";
import ComponentProduct from "../component/componentProduct";
import AssemblyInstructions from "./assemblyInstructions";
import AdditionalInfo from "./additionalInfo";
import constants from "../../../helper/constants";
import PreQualificationModule from "../packagedSolution/preQualificationModule";
import CustomAttributes from "./customAttributes";
import EnrichmentConfig from "./enrichmentConfig";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import ManageCustomersHierarchy from "../../sales/manageCustomers/manageCustomersHierarchy";
import { Grid, Toolbar } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import Draggable from "react-draggable";
import { Paper } from "@mui/material";
import ComponentCustomers from "./componentCustomers";
import BusApiCall from "../../../helper/axios";
import ComponentBOM from "../packagedSolution/componentBOM";
import moment from "moment";
import { Tooltip } from "@mui/material";
import ComponentComments from "./componentComments";
import EditSpecCharacteristicsAppl from "./specification/editSpecCharacteristicsAppl.js";
// import { makeStyles } from '@mui/styles';
import { Stepper, Step, StepLabel, Snackbar } from "@mui/material";
import { Alert } from "@mui/material";
import StepperNew from "../../../component/stepper/stepperNew";
import { toApi, fromApi } from "./specification/characteristicMapper";
import UnsavedChangesWarning from "../../../helper/unsavedChangesWarning";
import { useNavigate } from "react-router-dom";
import { withNavigation } from "../../../helper/withNavigation.js";
import DraggableResizablePaper from "../../../component/resizablePaper/resizablePaper";

const ComponentDialog = (props) => {
  const t = props.t;

  const editorRef = useRef(null);
  const [data, setData] = useState({});
  const [language, setLanguage] = useState("en_US");
  const [renderImage, setRenderImage] = useState(false);
  const routingData = {
    name: "",
    description: "",
    routingTasks: [],
  };
  const [customAttributesList, setCustomAttributesList] = useState([]);
  const [readonlyMode, setReadonlyMode] = useState(false);
  const [specificationAvailable, setSpecificationAvailable] = useState(
    props.productSpecificationsCount > 0 &&
    props.menuPaths.includes("/specification"),
  );
  const [showSaveCharacteristicMessage, setShowSaveCharacteristicMessage] =
    useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [responseSeverity, setResponseSeverity] = useState("info"); // 'success', 'error', 'warning', 'info'

  const [unsavedChangesWarning, setUnsavedChangesWarning] = useState(false);
  const [openUnsavedChangesModal, setOpenUnsavedChangesModal] = useState(false);
  const history = useNavigate();
  const [pendingNavigation, setPendingNavigation] = useState(null);

  const showResponseMessage = (message, severity = "info") => {
    setResponseMessage(message);
    setResponseSeverity(severity);
  };

  const handleCloseSnackbar = () => {
    setResponseMessage("");
  };

  const getDynamicSteps = () => {
    const allSteps = [
      { key: "DETAILS", label: t("DETAILS"), originalStep: 0 },
      {
        key: "PRODUCT_SPECIFICATIONS",
        label: t("PRODUCT_SPECIFICATIONS"),
        originalStep: 1,
      },
      {
        key: "CUSTOM_ATTRIBUTES",
        label: t("CUSTOM_ATTRIBUTES"),
        originalStep: 2,
      },
      {
        key: "ENRICHMENT_CONFIG",
        label: t("ENRICHMENT_CONFIG"),
        originalStep: 3,
      },
      { key: "FULFILMENT", label: t("FULFILMENT"), originalStep: 4 },
      {
        key: "ASSEMBLY_INSTRUCTIONS",
        label: t("ASSEMBLY_INSTRUCTIONS"),
        originalStep: 5,
      },
      { key: "ADDITIONAL_INFO", label: t("ADDITIONAL_INFO"), originalStep: 6 },
      { key: "CUSTOMERS", label: t("CUSTOMERS"), originalStep: 7 },
      { key: "HISTORY", label: t("HISTORY"), originalStep: 8 },
    ];

    const dynamicSteps = [];

    dynamicSteps.push(allSteps[0]);
    if (specificationAvailable) {
      dynamicSteps.push(allSteps[1]);
    }
    if (customAttributesList.length > 0 || checkCustomAttribute()) {
      dynamicSteps.push(allSteps[2]);
    }
    if (props.channelList && props.channelList.length > 0) {
      dynamicSteps.push(allSteps[3]);
    }
    dynamicSteps.push(allSteps[4]);
    if (props.addComponentType === "assembly") {
      dynamicSteps.push(allSteps[5]);
    }
    if (data.sellable) {
      dynamicSteps.push(allSteps[6]);
    }
    if (props.providerType === "SALES_CHNL_PROVIDER") {
      dynamicSteps.push(allSteps[7]);
    }
    if (
      props.mode === "edit" ||
      (props.addComponentType === "component" && !data.sellable) ||
      props.addComponentType === "assembly"
    ) {
      dynamicSteps.push(allSteps[8]);
    }

    return dynamicSteps;
  };
  const getCurrentStepIndex = () => {
    const dynamicSteps = getDynamicSteps();
    const currentStepIndex = dynamicSteps.findIndex(
      (stepObj) => stepObj.originalStep === step,
    );
    return currentStepIndex >= 0 ? currentStepIndex : 0;
  };

  useEffect(() => {
    setLanguage("en_US");
    if (props.readonlyMode) {
      setReadonlyMode(true);
    } else {
      setReadonlyMode(false);
    }
    if (props.mode === "edit") {
      if (props.editData.status == "P_PUBLISHED") {
        setPersistantError({
          key: t("PRODUCT_PUBLISHED"),
          show: true,
        });
      }
      let intialData = {
        name: props.editData.name,
        localisedName: props.editData.localisedName,
        featureCode: props.editData.featureCode,
        description: props.editData.description,
        localisedDesc: props.editData.localisedDesc,
        price: props.editData.price,
        priceType: props.editData.priceType,
        variants: props.editData.variants ? props.editData.variants : [],
        hasVariants: props.editData.hasVariants
          ? props.editData.hasVariants
          : props.editData.variants && props.editData.variants.length > 0
            ? true
            : false,
        physical: props.editData.physical,
        inventoried: props.editData.inventoried,
        rawMaterial: props.editData.rawMaterial,
        sellable: props.editData.sellable,
        inventoryItemType: props.editData.inventoryItemType
          ? props.editData.inventoryItemType
          : "NON_SERIALIZED_ITEM",
        preQuals: props.editData.preQuals ? props.editData.preQuals : [],
        priceTenureUOM: props.editData.priceTenureUOM
          ? props.editData.priceTenureUOM
          : "TF_day",
        priceTenure: props.editData.priceTenure
          ? props.editData.priceTenure
          : 1,
        customAttributes: props.editData.customAttributes
          ? props.editData.customAttributes
          : [],
        enrichmentConfig: [],
        bom: props.editData.bom,
        releaseDate: dateValidator(
          props.editData.releaseDate ? props.editData.releaseDate : "",
        ),
        expiryDate: dateValidator(
          props.editData.expiryDate ? props.editData.expiryDate : "",
        ),
        otherPrices:
          props.editData.otherPrices && props.editData.otherPrices.length > 0
            ? props.editData.otherPrices
            : [],
        status: props.editData.status,
        history: props.editData.history,
      };
      if (props.addComponentType === "assembly") {
        intialData.children = props.editData.children
          ? props.editData.children
          : [];
        intialData.routing = props.editData.routing
          ? props.editData.routing
          : routingData;
      }
      if (props.editData.basicDetail) {
        intialData.basicDetail = props.editData.basicDetail;
        intialData.orderApproval = props.editData.orderApproval;
        intialData.billingTriggerPhase = props.editData.billingTriggerPhase;

        if (props.editData.basicDetail.productMainImage) {
          var imageUrl =
            constants.imageUrl + props.editData.basicDetail.productMainImage;
          toDataUrl(imageUrl).then((img) => {
            intialData.basicDetail.productMainImageSource = img;
            setRenderImage(true);
          });
        }
      }

      setInitalCustomers(
        props.editData.customer ? props.editData.customer : [],
      );

      if (props.editData.provisioning) {
        for (let i = 0; i < props.provisioningResources.length; i++) {
          if (
            props.provisioningResources[i].resourceId ===
            props.editData.provisioning.resourceId
          ) {
            props.provisioningResources[i].targetAddress =
              props.editData.provisioning.targetAddress;
            setSelectedFulfilment(props.provisioningResources[i]);
          }
        }
        if (props.editData.provisioning.extraFields) {
          setFulfilmentFields(props.editData.provisioning.extraFields);
        }
        if (props.editData.provisioning.parameters) {
          setFulfilmentTableFields(
            JSON.parse(props.editData.provisioning.parameters),
          );
        }
        if (props.editData.provisioning.paramsUpdatable) {
          setFulfilmentTableEditable(
            props.editData.provisioning.paramsUpdatable,
          );
        }
        if ("STD_VM_PROV" === props.editData.provisioning.resourceId) {
          setShowDefaultValue(true);
        }
      }
      if (props.editData.activation) {
        for (let i = 0; i < props.activationResources.length; i++) {
          if (
            props.activationResources[i].resourceId ===
            props.editData.activation.resourceId
          ) {
            props.activationResources[i].targetAddress =
              props.editData.activation.targetAddress;
            setSelectedActivation(props.activationResources[i]);
          }
        }
        if (props.editData.activation.extraFields) {
          setActivationFields(props.editData.activation.extraFields);
        }
        if (props.editData.activation.parameters) {
          setActivationTableFields(
            JSON.parse(props.editData.activation.parameters),
          );
        }
        if (props.editData.activation.paramsUpdatable) {
          setActivationTableEditable(props.editData.activation.paramsUpdatable);
        }
      }
      if (props.editData.suspendResource) {
        for (let i = 0; i < props.suspendResources.length; i++) {
          if (
            props.suspendResources[i].resourceId ===
            props.editData.suspendResource.resourceId
          ) {
            props.suspendResources[i].targetAddress =
              props.editData.suspendResource.targetAddress;
            setSelectedSuspend(props.suspendResources[i]);
          }
        }
        if (props.editData.suspendResource.extraFields) {
          setSuspendFields(props.editData.suspendResource.extraFields);
        }
        if (props.editData.suspendResource.parameters) {
          setSuspendTableFields(
            JSON.parse(props.editData.suspendResource.parameters),
          );
        }
        if (props.editData.suspendResource.paramsUpdatable) {
          setSuspendTableEditable(
            props.editData.suspendResource.paramsUpdatable,
          );
        }
      }
      if (props.editData.resumeResource) {
        for (let i = 0; i < props.resumeResources.length; i++) {
          if (
            props.resumeResources[i].resourceId ===
            props.editData.resumeResource.resourceId
          ) {
            props.resumeResources[i].targetAddress =
              props.editData.resumeResource.targetAddress;
            setSelectedResume(props.resumeResources[i]);
          }
        }
        if (props.editData.resumeResource.extraFields) {
          setResumeFields(props.editData.resumeResource.extraFields);
        }
        if (props.editData.resumeResource.parameters) {
          setResumeTableFields(
            JSON.parse(props.editData.resumeResource.parameters),
          );
        }
        if (props.editData.resumeResource.paramsUpdatable) {
          setResumeTableEditable(props.editData.resumeResource.paramsUpdatable);
        }
      }
      if (props.originalBucketsData != undefined) {
        var tempCustomAttributesList = jp.query(
          props.originalBucketsData,
          '$[?(@.id=="' + props.componentType + '")]',
        );
        var allAttributeslist = [];
        if (
          tempCustomAttributesList &&
          tempCustomAttributesList.length > 0 &&
          tempCustomAttributesList[0].customAttributes &&
          tempCustomAttributesList[0].customAttributes.length > 0
        ) {
          for (
            var i = 0;
            i < tempCustomAttributesList[0].customAttributes.length;
            i++
          ) {
            var tempIndex = intialData.customAttributes.findIndex(
              (a) =>
                a.attrName ===
                tempCustomAttributesList[0].customAttributes[i].attrName,
            );
            if (tempIndex > -1) {
              intialData.customAttributes[tempIndex].valueType =
                tempCustomAttributesList[0].customAttributes[i].valueType;
              if (
                tempCustomAttributesList[0].customAttributes[i].valueType ===
                "boolean"
              ) {
                intialData.customAttributes[tempIndex].attrValue =
                  setBooleanFieldValue(
                    intialData.customAttributes[tempIndex].attrValue,
                  );
              }
            }
            if (tempCustomAttributesList[0].customAttributes[i].required) {
              var requiredItemIndex = intialData.customAttributes.findIndex(
                (a) =>
                  a.attrName ===
                  tempCustomAttributesList[0].customAttributes[i].attrName,
              );
              if (requiredItemIndex > -1) {
                intialData.customAttributes[requiredItemIndex].required = true;
              }
            } else {
              var itemIndex = intialData.customAttributes.findIndex(
                (a) =>
                  a.attrName ===
                  tempCustomAttributesList[0].customAttributes[i].attrName,
              );
              if (itemIndex > -1) {
              } else {
                var tempAttr = {
                  attrName:
                    tempCustomAttributesList[0].customAttributes[i].attrName,
                  required:
                    tempCustomAttributesList[0].customAttributes[i].required,
                  valueType:
                    tempCustomAttributesList[0].customAttributes[i].valueType,
                  options:
                    tempCustomAttributesList[0].customAttributes[i].options,
                };
                if (tempAttr.valueType === "boolean") {
                  tempAttr.attrValue = setBooleanFieldValue(
                    tempCustomAttributesList[0].customAttributes[i].attrValue,
                  );
                } else {
                  tempAttr.attrValue = tempCustomAttributesList[0]
                    .customAttributes[i].attrValue
                    ? tempCustomAttributesList[0].customAttributes[i].attrValue
                    : "";
                }
                allAttributeslist.push(tempAttr);
              }
            }
          }
          if (intialData.customAttributes.length === 0) {
            var requiredAttributes = jp.query(
              tempCustomAttributesList[0].customAttributes,
              "$[?(@.required)]",
            );
            for (var i = 0; i < requiredAttributes.length; i++) {
              var tempAttr = {
                attrName: requiredAttributes[i].attrName,
                required: requiredAttributes[i].required,
                valueType: requiredAttributes[i].valueType,
                options: requiredAttributes[i].options,
                create: true,
              };
              if (tempAttr.valueType === "boolean") {
                tempAttr.attrValue = setBooleanFieldValue(
                  requiredAttributes[i].attrValue,
                );
              } else {
                tempAttr.attrValue = requiredAttributes[i].attrValue
                  ? requiredAttributes[i].attrValue
                  : "";
              }
              intialData.customAttributes.push(tempAttr);
            }
          }
        }
        allAttributeslist = allAttributeslist.sort((a, b) =>
          a && b && a.attrName > b.attrName
            ? 1
            : b.attrName > a.attrName
              ? -1
              : 0,
        );
        setCustomAttributesList(allAttributeslist);
      }
      var tempEnrichmentConfig = [];
      var oldEnrichmentConfig = props.editData.enrichmentConfig
        ? props.editData.enrichmentConfig
        : {};
      if (
        oldEnrichmentConfig &&
        oldEnrichmentConfig.hasOwnProperty("purchaseable") &&
        oldEnrichmentConfig.purchaseable
      ) {
        var purchaseableList = oldEnrichmentConfig["purchaseable"].split(",");
        var removeableList = oldEnrichmentConfig["removeable"].split(",");
        var rePurchaseableList =
          oldEnrichmentConfig["rePurchaseable"].split(",");
        var visibleList = oldEnrichmentConfig["visible"].split(",");
        // Set purchaseable data
        for (var p = 0; p < purchaseableList.length; p++) {
          if (tempEnrichmentConfig.length > 0) {
            var ind = tempEnrichmentConfig.findIndex(
              (x) => x.id === purchaseableList[p].split(":")[0],
            );
            if (ind > -1) {
              tempEnrichmentConfig[ind].purchaseable = JSON.parse(
                purchaseableList[p].split(":")[1],
              );
            } else {
              var obj = {
                id: purchaseableList[p].split(":")[0],
                purchaseable: JSON.parse(purchaseableList[p].split(":")[1]),
              };
              tempEnrichmentConfig.push(obj);
            }
          } else {
            var obj = {
              id: purchaseableList[p].split(":")[0],
              purchaseable: JSON.parse(purchaseableList[p].split(":")[1]),
            };
            tempEnrichmentConfig.push(obj);
          }
        }
        // Set removeable data
        for (var p = 0; p < removeableList.length; p++) {
          if (tempEnrichmentConfig.length > 0) {
            var ind = tempEnrichmentConfig.findIndex(
              (x) => x.id === removeableList[p].split(":")[0],
            );
            if (ind > -1) {
              tempEnrichmentConfig[ind].removeable = JSON.parse(
                removeableList[p].split(":")[1],
              );
            } else {
              var obj = {
                id: removeableList[p].split(":")[0],
                removeable: JSON.parse(removeableList[p].split(":")[1]),
              };
              tempEnrichmentConfig.push(obj);
            }
          } else {
            var obj = {
              id: removeableList[p].split(":")[0],
              removeable: JSON.parse(removeableList[p].split(":")[1]),
            };
            tempEnrichmentConfig.push(obj);
          }
        }
        // Set rePurchaseable data
        for (var p = 0; p < rePurchaseableList.length; p++) {
          if (tempEnrichmentConfig.length > 0) {
            var ind = tempEnrichmentConfig.findIndex(
              (x) => x.id === rePurchaseableList[p].split(":")[0],
            );
            if (ind > -1) {
              tempEnrichmentConfig[ind].rePurchaseable = JSON.parse(
                rePurchaseableList[p].split(":")[1],
              );
            } else {
              var obj = {
                id: rePurchaseableList[p].split(":")[0],
                rePurchaseable: JSON.parse(rePurchaseableList[p].split(":")[1]),
              };
              tempEnrichmentConfig.push(obj);
            }
          } else {
            var obj = {
              id: rePurchaseableList[p].split(":")[0],
              rePurchaseable: JSON.parse(rePurchaseableList[p].split(":")[1]),
            };
            tempEnrichmentConfig.push(obj);
          }
        }
        // Set visible data
        for (var p = 0; p < visibleList.length; p++) {
          if (tempEnrichmentConfig.length > 0) {
            var ind = tempEnrichmentConfig.findIndex(
              (x) => x.id === visibleList[p].split(":")[0],
            );
            if (ind > -1) {
              tempEnrichmentConfig[ind].visible = JSON.parse(
                visibleList[p].split(":")[1],
              );
            } else {
              var obj = {
                id: visibleList[p].split(":")[0],
                visible: JSON.parse(visibleList[p].split(":")[1]),
              };
              tempEnrichmentConfig.push(obj);
            }
          } else {
            var obj = {
              id: visibleList[p].split(":")[0],
              visible: JSON.parse(visibleList[p].split(":")[1]),
            };
            tempEnrichmentConfig.push(obj);
          }
        }
      }
      intialData.enrichmentConfig = tempEnrichmentConfig;
      setData(intialData);
    } else {
      let intialData = {
        name: "",
        localisedName: [],
        featureCode: "",
        description: "",
        localisedDesc: [],
        price: 0,
        priceType: "",
        priceTenureUOM: "TF_mon",
        priceTenure: 1,
        variants: [],
        physical: false,
        inventoried: false,
        rawMaterial: false,
        sellable: false,
        inventoryItemType: "NON_SERIALIZED_ITEM",

        orderApproval: false,
        billingTriggerPhase: "DEFAULT",
        basicDetail: {
          categoryId: "",
          productOverview:
            '{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
          productTechSpecs:
            '{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
          productWhatsIncluded:
            '{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
          productMainImage: "",
          productMainImageSource: "",
          productAdditionalImage1: "",
          productAdditionalImage2: "",
          productAdditionalImage3: "",
          productAdditionalImage4: "",
          productAdditionalImage1Src: "",
          productAdditionalImage2Src: "",
          productAdditionalImage3Src: "",
          productAdditionalImage4Src: "",
          terms: [],
        },
        preQuals: [],
        customAttributes: [],
        enrichmentConfig: [],
        bom: null,
        otherPrices: [],
      };
      if (props.selectedCustomer) {
        var list = [...props.selectedCustomer];
        setInitalCustomers(list);
      } else {
        setInitalCustomers();
      }
      if (props.addComponentType === "assembly") {
        intialData.children = [];
        intialData.routing = routingData;
      }

      // var tempCustomAttributesList = jp.query(props.originalBucketsData, '$[?(@.id=="' + props.componentType + '")]');
      const tempCustomAttributesList = findCustomAttributes(
        props.originalBucketsData,
        props.componentType,
      );
      if (
        tempCustomAttributesList[0].customAttributes &&
        tempCustomAttributesList[0].customAttributes.length > 0
      ) {
        var requiredAttributes = jp.query(
          tempCustomAttributesList[0].customAttributes,
          "$[?(@.required)]",
        );
        for (var i = 0; i < requiredAttributes.length; i++) {
          var tempAttr = {
            attrName: requiredAttributes[i].attrName,
            required: requiredAttributes[i].required,
            valueType: requiredAttributes[i].valueType,
            options: requiredAttributes[i].options,
          };
          if (tempAttr.valueType === "boolean") {
            tempAttr.attrValue = setBooleanFieldValue(
              requiredAttributes[i].attrValue,
            );
          } else {
            tempAttr.attrValue = requiredAttributes[i].attrValue
              ? requiredAttributes[i].attrValue
              : "";
          }
          intialData.customAttributes.push(tempAttr);
        }
      } else {
        intialData.customAttributes = [];
      }
      setData(intialData);
      var allAttributeslist = [];
      if (
        tempCustomAttributesList[0].customAttributes &&
        tempCustomAttributesList[0].customAttributes.length > 0
      ) {
        for (
          var i = 0;
          i < tempCustomAttributesList[0].customAttributes.length;
          i++
        ) {
          if (!tempCustomAttributesList[0].customAttributes[i].required) {
            var tempAttr = {
              attrName:
                tempCustomAttributesList[0].customAttributes[i].attrName,
              required:
                tempCustomAttributesList[0].customAttributes[i].required,
              valueType:
                tempCustomAttributesList[0].customAttributes[i].valueType,
              options: tempCustomAttributesList[0].customAttributes[i].options,
            };
            if (tempAttr.valueType === "boolean") {
              tempAttr.attrValue = setBooleanFieldValue(
                tempCustomAttributesList[0].customAttributes[i].attrValue,
              );
            } else {
              tempAttr.attrValue = tempCustomAttributesList[0].customAttributes[
                i
              ].attrValue
                ? tempCustomAttributesList[0].customAttributes[i].attrValue
                : "";
            }
            allAttributeslist.push(tempAttr);
          }
        }
      }
      allAttributeslist = allAttributeslist.sort((a, b) =>
        a && b && a.attrName > b.attrName
          ? 1
          : b.attrName > a.attrName
            ? -1
            : 0,
      );
      setCustomAttributesList(allAttributeslist);
      setRenderImage(true);
    }
  }, []);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (unsavedChangesWarning) {
        e.preventDefault();
        e.returnValue = ""; // For Chrome
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [unsavedChangesWarning]);

  const setBooleanFieldValue = (value) => {
    if (value && isValidJson(value)) {
      return JSON.parse(value);
    } else {
      return false;
    }
  };

  const isValidJson = (val) => {
    try {
      JSON.parse(val);
    } catch (e) {
      return false;
    }
    return true;
  };

  const [step, newStep] = useState(0);

  const changeStep = (val) => {
    props.resetErrorMessage();
    setCustomAttributeError({
      error: "",
      show: false,
    });
    setError({
      key: "",
      show: false,
    });

    //map the step for stepper
    const dynamicSteps = getDynamicSteps();
    let targetStep = val;

    const stepExists = dynamicSteps.some((step) => step.originalStep === val);
    if (stepExists) {
      targetStep = val;
    } else {
      if (typeof val === "number" && val >= 0 && val < dynamicSteps.length) {
        targetStep = dynamicSteps[val].originalStep;
      }
    }
    if (targetStep === 0) {
      newStep(targetStep);
    } else {
      if (validateForm()) {
        newStep(targetStep);
      }
    }
  };

  const [error, setError] = useState({
    key: "",
    show: false,
  });

  const [persistantError, setPersistantError] = useState({
    key: "",
    show: false,
  });

  const [err, setErr] = useState({});
  const [errLocale, setErrLocale] = useState();

  const validateForm = () => {
    let error = {};
    let errLocale = "";
    let errorFound = false;

    var localisedNameIndex = data.localisedName.findIndex(
      (x) => x.locale === "en_US",
    );
    var localisedDescIndex = data.localisedDesc.findIndex(
      (x) => x.locale === "en_US",
    );

    if (!data.name) {
      error.name = `${t("NAME")} ${t("IS_REQUIRED")}`;
      errorFound = true;
    }
    if (data.name.length > 100) {
      error.name = t("PRODUCT_NAME") + " should be less than 100 characters";
      errorFound = true;
    }
    if (!data.featureCode) {
      error.featureCode = `${t("PRODUCT_CODE")} is ${t("IS_REQUIRED")}`;
      errorFound = true;
    }
    if (data.featureCode.length > 24) {
      error.featureCode =
        t("PRODUCT_CODE") + " should be less than 20 characters";
      errorFound = true;
    }
    if (!data.description) {
      error.description = `${t("DESCRIPTION")} ${t("IS_REQUIRED")}`;
      errorFound = true;
    }
    if (data.variants.length === 0) {
      //No price required for components with variants)
      if (data.price === "") {
        error.price = `${t("PRICE")} ${t("IS_REQUIRED")}`;
        errorFound = true;
      }
    }
    if (!data.priceType) {
      error.priceType = `${t("PRICE_TYPE")} ${t("IS_REQUIRED")}`;
      errorFound = true;
    }
    if (data.sellable) {
      if (!data.basicDetail.categoryId) {
        error.categoryId = t("CATEGORY") + t("IS_REQUIRED");
        errorFound = true;
      }
      if (data.priceType === "TERM") {
        if (!data.priceTenureUOM) {
          error.priceTenureUOM = "Term UOM " + t("IS_REQUIRED");
          errorFound = true;
        } else if (!data.priceTenure) {
          error.priceTenure = "Term Tenure " + t("IS_REQUIRED");
          errorFound = true;
        }
      }
    }
    if (data.priceType !== "NRC") {
      if (data.priceTenure && data.priceTenure < "1") {
        error.priceTenure = t("TERM_TENURE_GREATER_THAN_0");
        errorFound = true;
      }
    }
    if (data.expiryDate) {
      if (data.releaseDate > data.expiryDate) {
        error.expiryDate =
          "Expiry date cannot be before the release date :" + data.releaseDate;
        errorFound = true;
      }
    }
    if (data.variants && data.variants.length > 0) {
      error.variants = [];
      for (var v = 0; v < data.variants.length; v++) {
        if (data.variants[v].deleteId) {
        } else {
          var variantErr = {};
          if (!data.variants[v].name) {
            variantErr.variantName = "Variant name " + t("IS_REQUIRED");
            errorFound = true;
          }
          if (!data.variants[v].description) {
            variantErr.variantDescription =
              "Variant description " + t("IS_REQUIRED");
            errorFound = true;
          }
          if (!data.variants[v].price) {
            variantErr.variantPrice = "Variant price " + t("IS_REQUIRED");
            errorFound = true;
          }
          if (!data.variants[v].featureCode) {
            variantErr.variantProductCodeError =
              "Variant product code " + t("IS_REQUIRED");
            errorFound = true;
          }
          error.variants.push(variantErr);
        }
      }
      const productCodes = data.variants
        .filter((item) => !item.deleteId && item.featureCode)
        .map((opt) => opt.featureCode);
      const duplicateCodes = productCodes.filter(
        (code, index) => productCodes.indexOf(code) !== index,
      );

      if (duplicateCodes.length > 0) {
        error.variantDuplicateProductCodeError = t(
          "DUPLICATE_PRODUCT_CODE_ERROR",
          { codes: duplicateCodes.join(", ") },
        );
        errorFound = true;
      }
    }
    if (localisedNameIndex == -1) {
      errLocale = "Please add a Name in english language";
      errorFound = true;
    } else if (
      localisedNameIndex > -1 &&
      data.localisedName[localisedNameIndex].text == ""
    ) {
      errLocale = "Please add a Name in english language";
      errorFound = true;
    } else if (localisedDescIndex == -1) {
      errLocale = "Please add a Description in english language";
      errorFound = true;
    } else if (
      localisedDescIndex > -1 &&
      data.localisedDesc[localisedDescIndex].text == ""
    ) {
      errLocale = "Please add a Description in english language";
      errorFound = true;
    }
    setErr(error);
    setErrLocale(errLocale);
    // if ((Object.keys(error).length === 0) && !errLocale) {
    //     return true;
    // }
    console.log("check error", error);
    if (errorFound) {
      return false;
    } else {
      return true;
    }
  };

  const dateValidator = (date) => {
    if (date === undefined || date === null || date == "") {
      date = "";
    } else {
      date = moment(date).format("yyyy-MM-DD");
    }
    return date;
  };

  // const validateForm = () => {
  //     let errCount = 0;
  //     let key = '';

  //     var localisedNameIndex = data.localisedName.findIndex((x) => x.locale === "en_US");
  //     var localisedDescIndex = data.localisedDesc.findIndex((x) => x.locale === "en_US");

  //     if (!data.name) {
  //          errCount = errCount + 1;
  //          key = 'name ' + t('IS_REQUIRED');
  //     } else if (!data.featureCode) {
  //          errCount = errCount + 1;
  //          key = 'product code ' + t('IS_REQUIRED');
  //     } else if (data.featureCode.length > 50){
  //          errCount = errCount + 1;
  //          key = 'product code should be less than 20 characters';
  //     } else if (!data.description) {
  //          errCount = errCount + 1;
  //          key = 'description ' + t('IS_REQUIRED');
  //     } else if (!data.price && data.variants === undefined) { //No price required for components with variants)
  //          errCount = errCount + 1;
  //          key = 'price ' + t('IS_REQUIRED');
  //     } else if (!data.priceType) {
  //          errCount = errCount + 1;
  //          key = 'price type ' + t('IS_REQUIRED');
  //     } else if (data.sellable) {
  //         if (!data.basicDetail.categoryId) {
  //              errCount = errCount + 1;
  //              key = 'category ' + t('IS_REQUIRED');
  //          } else if (!data.basicDetail.productMainImage) {
  //              errCount = errCount + 1;
  //              key = 'image ' + t('IS_REQUIRED');
  //         } else if (data.priceType === 'TERM') {
  //             if (!data.priceTenureUOM) {
  //                 errCount = errCount + 1;
  //                 key = 'term UOM ' + t('IS_REQUIRED');
  //             } else if (!data.priceTenure) {
  //                 errCount = errCount + 1;
  //                 key = 'term tenure ' + t('IS_REQUIRED');
  //             } else {
  //                 return true;
  //             }
  //         } else {
  //             return true;
  //         }
  //     } else if (data.priceType === 'TERM') {
  //         if (!data.priceTenureUOM) {
  //             errCount = errCount + 1;
  //             key = 'term UOM ' + t('IS_REQUIRED');
  //         } else if (!data.priceTenure) {
  //             errCount = errCount + 1;
  //             key = 'term tenure ' + t('IS_REQUIRED');
  //         } else {
  //             return true;
  //         }
  // } else if (localisedNameIndex == -1) {
  //     errCount = errCount + 1;
  //     key = '- Name in english language';
  // } else if (localisedNameIndex > -1 && data.localisedName[localisedNameIndex].text == '') {
  //     errCount = errCount + 1;
  //     key = '- Name in english language';
  // } else if (localisedDescIndex == -1) {
  //     errCount = errCount + 1;
  //     key = '- Description in english language';
  // } else if (localisedDescIndex > -1 && data.localisedDesc[localisedDescIndex].text == '') {
  //     errCount = errCount + 1;
  //     key = '- Description in english language';
  // } else {
  //         return true;
  //     }
  //     if (errCount == 0) {
  //         return true;
  //     } else if (errCount == 1) {
  //         setError({
  //             key: key,
  //             show: true
  //         })
  //         return false;
  //     } else {
  //         setError({
  //             key: 'All fields marked as *',
  //             show: true
  //         })
  //         return false;
  //     }
  // }

  const onChangeForm = (e) => {
    let error = {};
    setUnsavedChangesWarning(true);
    if (e.target.value !== " ") {
      // setError({
      //     key: '',
      //     show: false
      // })
      setErr({
        ...err,
        [e.target.name]: "",
      });
      setErrLocale("");
      let tempData = { ...data };
      if (e.target.name === "price") {
        if (e.target.value >= 0) {
          let t = e.target.value;
          tempData[e.target.name] = e.value =
            t.indexOf(".") >= 0
              ? t.substr(0, t.indexOf(".")) + t.substr(t.indexOf("."), 3)
              : t;
          setData(tempData);
        } else {
          tempData[e.target.name] = 0;
          setData(tempData);
        }
      }
      if (e.target.name === "name" && e.target.value.length > 100) {
        error.name = t("MAX_100_CHARACTER_ERROR");
        return;
        // props.setErrorMessage(t('MAX_100_CHARACTER_ERROR'), false)
      }
      if (e.target.name === "featureCode" && e.target.value.length > 20) {
        error.featureCode = t("MAX_20_CHARACTER_ERROR");
        return;
        // props.setErrorMessage(t('MAX_100_CHARACTER_ERROR'), false)
      }
      if (
        e.target.name === "physical" ||
        e.target.name === "sellable" ||
        e.target.name === "rawMaterial" ||
        e.target.name === "inventoried" ||
        e.target.name === "hasVariants"
      ) {
        tempData[e.target.name] = e.target.checked;
        if (e.target.name === "physical") {
          if (e.target.checked) {
          } else {
            tempData["rawMaterial"] = false;
            tempData["inventoryItemType"] = "NON_SERIALIZED_ITEM";
          }
        }
        if (!tempData.basicDetail) {
          tempData.orderApproval = false;
          tempData.billingTriggerPhase = "DEFAULT";
          tempData.basicDetail = {
            categoryId: "",
            productOverview:
              '{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
            productTechSpecs:
              '{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
            productWhatsIncluded:
              '{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
            productMainImage: "",
            productMainImageSource: "",
            productAdditionalImage1: "",
            productAdditionalImage2: "",
            productAdditionalImage3: "",
            productAdditionalImage4: "",
            productAdditionalImage1Src: "",
            productAdditionalImage2Src: "",
            productAdditionalImage3Src: "",
            productAdditionalImage4Src: "",
            terms: [],
          };
          setRenderImage(true);
        }
        setData(tempData);
      } else if (e.target.name === "orderApproval") {
        tempData[e.target.name] = !tempData[e.target.name];
        setData(tempData);
      } else if (e.target.name === "priceTenure") {
        if (e.target.value >= 0) {
          tempData[e.target.name] = e.target.value;
          setData(tempData);
        } else {
          tempData[e.target.name] = "";
          setData(tempData);
        }
      } else {
        setInputTextBasedOnLocale(e, tempData);
        props.setErrorMessage("", false);
        tempData[e.target.name] = e.target.value;
        setData(tempData);
      }
      setErr(error);
    }
  };

  const addOtherPrice = () => {
    var tempData = { ...data };
    var defaultOption = "";
    for (var i = 0; i < props.priceOptions.length; i++) {
      if (defaultOption) {
      } else {
        if (!props.priceOptions[i].disabled) {
          defaultOption = props.priceOptions[i].value;
        }
      }
    }
    var opt = {
      price: "0",
      priceType: defaultOption,
      add: true,
    };
    if (defaultOption === "USAGE_CHARGE") {
      opt.priceTenureUOM = "TF_hr";
      opt.priceTenure = 1;
    }
    // if (tempData.otherPrices && Array.isArray(tempData.otherPrices)) {
    //     tempData.otherPrices.push(opt);
    // } else {
    //     tempData.otherPrices = [];
    //     tempData.otherPrices.push(opt);
    // }
    if (Array.isArray(tempData.otherPrices)) {
      tempData.otherPrices.push(opt);
    } else {
      tempData.otherPrices = [opt]; // Initialize if it doesn't exist
    }
    props.disableOtherPriceOption(tempData.otherPrices);
    setData(tempData);
  };

  const onChangeOtherPrice = (e, index) => {
    var tempData = { ...data };
    setUnsavedChangesWarning(true);
    if (tempData.otherPrices[index].id) {
      tempData.otherPrices[index].edit = true;
    }
    if (e.target.name === "priceType") {
      if (e.target.value === "USAGE_CHARGE") {
        if (tempData.otherPrices[index].priceTenure) {
        } else {
          tempData.otherPrices[index].priceTenureUOM = "TF_hr";
          tempData.otherPrices[index].priceTenure = 1;
        }
      } else {
        delete tempData.otherPrices[index].priceTenureUOM;
        delete tempData.otherPrices[index].priceTenure;
      }
    }
    if (e.target.name === "price") {
      if (e.target.value >= 0) {
        let t = e.target.value;
        tempData.otherPrices[index][e.target.name] = e.value =
          t.indexOf(".") >= 0
            ? t.substr(0, t.indexOf(".")) + t.substr(t.indexOf("."), 3)
            : t;
      } else {
        tempData.otherPrices[index][e.target.name] = 0;
      }
    } else {
      tempData.otherPrices[index][e.target.name] = e.target.value;
    }
    props.disableOtherPriceOption(tempData.otherPrices);
    setData(tempData);
  };

  const deleteOtherPrice = (index) => {
    var tempData = { ...data };
    if (tempData.otherPrices[index].id) {
      tempData.otherPrices[index].remove = true;
      tempData.otherPrices[index].edit = false;
    } else {
      tempData.otherPrices.splice(index, 1);
    }
    props.disableOtherPriceOption(tempData.otherPrices);
    setData(tempData);
  };

  const addOtherPricesOnVariant = (e, variantIndex) => {
    let tempData = { ...data };
    var defaultOption = "";
    for (
      var i = 0;
      i < tempData.variants[variantIndex].priceOptions.length;
      i++
    ) {
      if (defaultOption) {
      } else {
        if (!tempData.variants[variantIndex].priceOptions[i].disabled) {
          defaultOption = tempData.variants[variantIndex].priceOptions[i].value;
        }
      }
    }
    var opt = {
      price: "0",
      priceType: defaultOption,
      add: true,
    };
    if (defaultOption === "USAGE_CHARGE") {
      opt.priceTenureUOM = "TF_hr";
      opt.priceTenure = 1;
    }
    if (
      tempData.variants.length > 0 &&
      tempData.variants[variantIndex] &&
      opt.priceType
    ) {
      if (Array.isArray(tempData.variants[variantIndex].otherPrices)) {
        tempData.variants[variantIndex].otherPrices.push(opt);
      } else {
        tempData.variants[variantIndex].otherPrices = [opt]; // Initialize if it doesn't exist
      }
      // props.disableOtherPriceOption(tempData.variants[variantIndex].otherPrices);
      setData(tempData);
      disableOtherPriceOptionOnVariant(
        tempData.variants[variantIndex].otherPrices,
        variantIndex,
      );
    }
  };

  const disableOtherPriceOptionOnVariant = (list, variantIndex) => {
    let tempData = { ...data };
    var allOtherPricesList = [...tempData.variants[variantIndex].priceOptions];
    allOtherPricesList.forEach((obj) => {
      obj.disabled = false;
    });
    if (list && list.length > 0) {
      var tempList = [];

      for (var i = 0; i < allOtherPricesList.length; i++) {
        // Check if there are any items with the current priceType in the list
        let items = jp.query(
          list,
          '$..[?(@.priceType=="' + allOtherPricesList[i].value + '")]',
        );

        if (items.length > 0) {
          // If any of the items is not marked as removed, disable the option
          const anyNotRemoved = items.some((item) => !item.remove);

          if (anyNotRemoved) {
            tempList.push({ ...allOtherPricesList[i], disabled: true });
          } else {
            // If all items are removed, keep the option enabled
            tempList.push(allOtherPricesList[i]);
          }
        } else {
          // If no items with the priceType exist, keep the option enabled
          tempList.push(allOtherPricesList[i]);
        }
      }

      tempData.variants[variantIndex].priceOptions = tempList;
      setData(tempData);
    } else {
      var tempList = allOtherPricesList;
      tempData.variants[variantIndex].priceOptions = tempList;
      setData(tempData);
    }
  };

  const onChangeOtherPriceVariant = (e, index, variantIndex) => {
    var tempData = { ...data };
    setUnsavedChangesWarning(true);
    if (tempData.variants.length > 0 && tempData.variants[variantIndex]) {
      if (tempData.variants[variantIndex].otherPrices[index].id) {
        tempData.variants[variantIndex].otherPrices[index].edit = true;
      }
      if (e.target.name === "priceType") {
        if (e.target.value === "USAGE_CHARGE") {
          if (tempData.variants[variantIndex].otherPrices[index].priceTenure) {
          } else {
            tempData.variants[variantIndex].otherPrices[index].priceTenureUOM =
              "TF_hr";
            tempData.variants[variantIndex].otherPrices[index].priceTenure = 1;
          }
        } else {
          delete tempData.variants[variantIndex].otherPrices[index]
            .priceTenureUOM;
          delete tempData.variants[variantIndex].otherPrices[index].priceTenure;
        }
      }
      if (e.target.name === "price") {
        if (e.target.value >= 0) {
          let t = e.target.value;
          tempData.variants[variantIndex].otherPrices[index][e.target.name] =
            e.value =
            t.indexOf(".") >= 0
              ? t.substr(0, t.indexOf(".")) + t.substr(t.indexOf("."), 3)
              : t;
        } else {
          tempData.variants[variantIndex].otherPrices[index][e.target.name] = 0;
        }
      } else {
        tempData.variants[variantIndex].otherPrices[index][e.target.name] =
          e.target.value;
      }
      setData(tempData);
      disableOtherPriceOptionOnVariant(
        tempData.variants[variantIndex].otherPrices,
        variantIndex,
      );
    }
  };

  const deleteOtherPriceOnVariant = (e, index, variantIndex) => {
    let tempData = { ...data };
    if (tempData.variants.length > 0 && tempData.variants[variantIndex]) {
      if (tempData.variants[variantIndex].otherPrices[index].id) {
        tempData.variants[variantIndex].otherPrices[index].remove = true;
      } else {
        tempData.variants[variantIndex].otherPrices.splice(index, 1);
      }
      setData(tempData);
      disableOtherPriceOptionOnVariant(
        tempData.variants[variantIndex].otherPrices,
        variantIndex,
      );
    }
  };

  const setInputTextBasedOnLocale = (e, tempData) => {
    let value = {};
    if (e.target.name === "name") {
      const hasLocale = tempData.localisedName.some((obj) => {
        if (obj.locale === language) {
          return true;
        }
      });
      if (!hasLocale) {
        value = {
          locale: language,
          text: e.target.value,
        };
        tempData.localisedName.push(value);
      } else {
        var index = tempData.localisedName.findIndex(
          (x) => x.locale === language,
        );
        tempData.localisedName[index].text = e.target.value;
      }
    } else if (e.target.name === "description") {
      const hasLocale = tempData.localisedDesc.some((obj) => {
        if (obj.locale === language) {
          return true;
        }
      });
      if (!hasLocale) {
        value = {
          locale: language,
          text: e.target.value,
        };
        tempData.localisedDesc.push(value);
      } else {
        var index = tempData.localisedDesc.findIndex(
          (x) => x.locale === language,
        );
        tempData.localisedDesc[index].text = e.target.value;
      }
    }
  };

  const onLanguageChange = (e) => {
    setLanguage(e.target.value);
    let tempData = { ...data };

    if (tempData.localisedName) {
      var index = tempData.localisedName.findIndex(
        (x) => x.locale === e.target.value,
      );
      if (index > -1) {
        tempData.name = tempData.localisedName[index].text;
      } else {
        tempData.name = "";
      }
    }

    if (tempData.localisedDesc) {
      var descindex = tempData.localisedDesc.findIndex(
        (x) => x.locale === e.target.value,
      );
      if (descindex > -1) {
        tempData.description = tempData.localisedDesc[descindex].text;
      } else {
        tempData.description = "";
      }
    }

    setData(tempData);
  };

  const onChangeBasicDetail = (e) => {
    setUnsavedChangesWarning(true);
    if (e.target.value !== " ") {
      // setError({
      //     key: '',
      //     show: false
      // })
      setErr({
        ...err,
        [e.target.name]: "",
      });
      let tempData = { ...data };
      let basicData = { ...tempData.basicDetail };
      props.setErrorMessage("", false);
      basicData[e.target.name] = e.target.value;
      tempData.basicDetail = basicData;
      setData(tempData);
    }
  };

  const save = (editorData, name) => {
    let tempData = { ...data };
    let basicData = { ...tempData.basicDetail };
    basicData[name] = editorData;
    tempData.basicDetail = basicData;
    setData(tempData);
  };

  // const onImageChange = (e, srcImage) => {
  //     let tempData = { ...data };
  //     let basicData = { ...tempData.basicDetail };
  //     if (e.target.files.length > 0) {
  //         var fileName = e.target.files[0].name;
  //         var name = e.target.name;
  //         let file = e.target.files[0];
  //         Resizer.imageFileResizer(
  //             file,
  //             300,
  //             300,
  //             'PNG',
  //             100,
  //             0,
  //             uri => {
  //                 setTimeout(function () {
  //                     basicData[name] = fileName;
  //                     basicData[srcImage] = uri;
  //                     tempData.basicDetail = basicData;
  //                     setData(tempData);
  //                 }.bind(this), 1000)
  //             },
  //             'base64'
  //         );
  //     }
  // }

  const onImageChange = (e, srcImage) => {
    let tempData = { ...data };
    let basicData = { ...tempData.basicDetail };

    if (e.target.files.length > 0) {
      const file = e.target.files[0];
      const fileName = file.name;
      const name = e.target.name;

      const reader = new FileReader();
      reader.onload = (event) => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement("canvas");
          const maxWidth = 300;
          const maxHeight = 300;

          let width = img.width;
          let height = img.height;

          // maintain aspect ratio
          if (width > height) {
            if (width > maxWidth) {
              height = Math.round((height *= maxWidth / width));
              width = maxWidth;
            }
          } else {
            if (height > maxHeight) {
              width = Math.round((width *= maxHeight / height));
              height = maxHeight;
            }
          }

          canvas.width = width;
          canvas.height = height;

          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, width, height);

          const uri = canvas.toDataURL("image/png", 1.0); // 100% quality

          // update your state, same as before
          setTimeout(() => {
            basicData[name] = fileName;
            basicData[srcImage] = uri;
            tempData.basicDetail = basicData;
            setData(tempData);
          }, 1000);
        };

        img.onerror = (err) => {
          console.error("Image load error:", err);
        };

        img.src = event.target.result;
      };

      reader.onerror = (err) => {
        console.error("File read error:", err);
      };

      reader.readAsDataURL(file);
    }
  };

  const [termsData, changeTermsData] = useState({
    termsUrl: "",
    termsText: "",
  });

  const [termCondToEdit, setTermDataToEdit] = useState(null);

  const onChangeTerms = (e) => {
    setUnsavedChangesWarning(true);
    let term = { ...termsData };
    term[e.target.name] = e.target.value;
    changeTermsData(term);
  };

  const updateTermsCond = () => {
    if (termsData.termsText && termsData.termsUrl) {
      let tempData = { ...data };
      let basicData = { ...tempData.basicDetail };
      basicData.terms[termCondToEdit.index].termsText = termsData.termsText;
      basicData.terms[termCondToEdit.index].termsUrl = termsData.termsUrl;
      tempData.basicDetail = basicData;
      setData(tempData);
      changeTermsData({
        termsUrl: "",
        termsText: "",
      });
      setTermDataToEdit(null);
    }
  };

  const cancelUpdateTermsCond = () => {
    changeTermsData({
      termsUrl: "",
      termsText: "",
    });
    setTermDataToEdit(null);
  };

  const addTermsCond = () => {
    if (termsData.termsText && termsData.termsUrl) {
      let tempData = { ...data };
      let basicData = { ...tempData.basicDetail };
      basicData.terms = basicData.terms ? [...basicData.terms] : [];
      basicData.terms.push({
        termsText: termsData.termsText,
        termsUrl: termsData.termsUrl,
      });
      tempData.basicDetail = basicData;
      setData(tempData);
      changeTermsData({
        termsUrl: "",
        termsText: "",
      });
    }
  };

  const removeTermAndCond = (index) => {
    let tempData = { ...data };
    let basicData = { ...tempData.basicDetail };
    basicData.terms.splice(index, 1);
    tempData.basicDetail = basicData;
    setData(tempData);
  };

  const editTermAndCond = (item, index) => {
    let data = item;
    data.index = index;
    setTermDataToEdit(data);
    changeTermsData(item);
  };

  const [selectedFulfilmentResource, setSelectedFulfilment] = useState({
    resourceName: ''
  });
  const [fulfilmentConnectionFields, setFulfilmentFields] = useState({});
  const [fulfilmentTableFields, setFulfilmentTableFields] = useState([]);
  const [fulfilmentTableEditable, setFulfilmentTableEditable] = useState(false);
  const [showDefaultValue, setShowDefaultValue] = useState(false);

  const [selectedActivationResource, setSelectedActivation] = useState({
    resourceName: ''
  });
  const [activationConnectionFields, setActivationFields] = useState({});
  const [activationTableFields, setActivationTableFields] = useState([]);
  const [activationTableEditable, setActivationTableEditable] = useState(false);

  const [selectedSuspendResource, setSelectedSuspend] = useState({
    resourceName: ''
  });
  const [suspendConnectionFields, setSuspendFields] = useState({});
  const [suspendTableFields, setSuspendTableFields] = useState([]);
  const [suspendTableEditable, setSuspendTableEditable] = useState(false);

  const [selectedResumeResource, setSelectedResume] = useState({
    resourceName: ''
  });
  const [resumeConnectionFields, setResumeFields] = useState({});
  const [resumeTableFields, setResumeTableFields] = useState([]);
  const [resumeTableEditable, setResumeTableEditable] = useState(false);

  // Resources
  const selectResource = (object, type) => {
    if (object === null) {
      object = {
        resourceName: ''
      }
    }
    let connectionFields = {};
    let parameters = [];
    let paramsUpdatable = false;
    if (object) {
      if (object.connectionFields && object.connectionFields.length > 0) {
        object.connectionFields.map((field, i) => {
          connectionFields[field] = "";
        });
      }
      if (object.parameters && object.parameters !== null) {
        parameters = JSON.parse(object.parameters);
      }
      paramsUpdatable = object.paramsUpdatable ? object.paramsUpdatable : false;
    } else {
      object = {};
    }
    if (type === "FULFILMENT") {
      setSelectedFulfilment(object);
      setFulfilmentFields(connectionFields);
      setFulfilmentTableFields(parameters);
      setFulfilmentTableEditable(paramsUpdatable);
      if ("STD_VM_PROV" === object.resourceId) {
        setShowDefaultValue(true);
      }
    } else if (type === "ACTIVATION") {
      setSelectedActivation(object);
      setActivationFields(connectionFields);
      setActivationTableFields(parameters);
      setActivationTableEditable(paramsUpdatable);
    } else if (type === "SUSPEND") {
      setSelectedSuspend(object);
      setSuspendFields(connectionFields);
      setSuspendTableFields(parameters);
      setSuspendTableEditable(paramsUpdatable);
      if (!object.resourceId) {
        setSelectedResume({});
        setResumeFields({});
        setResumeTableFields([]);
        setResumeTableEditable(false);
      }
    } else if (type === "RESUME") {
      setSelectedResume(object);
      setResumeFields(connectionFields);
      setResumeTableFields(parameters);
      setResumeTableEditable(paramsUpdatable);
    } else if (type === "QUALIFICATION") {
      setSelectedResource(object);
      setConnectionFields(connectionFields);
      setTableFields(parameters);
      setTableEditable(paramsUpdatable);
    }
  };

  const updateConnectionFields = (e, type) => {
    if (type === "FULFILMENT") {
      let tempData = { ...fulfilmentConnectionFields };
      tempData[e.target.name] = e.target.value;
      setFulfilmentFields(tempData);

      let tempResource = { ...selectedFulfilmentResource };
      if (selectedFulfilmentResource.targetTypeId === "EMAIL") {
        tempResource.targetAddress = e.target.value;
      } else if (selectedFulfilmentResource.targetTypeId === "REST_ENDPOINT") {
        if (e.target.name === "URL") {
          tempResource.targetAddress = e.target.value;
        } else {
          tempResource.targetAddress = "";
        }
      } else {
        tempResource.targetAddress = "";
      }
      setSelectedFulfilment(tempResource);
    } else if (type === "ACTIVATION") {
      let tempData = { ...activationConnectionFields };
      tempData[e.target.name] = e.target.value;
      setActivationFields(tempData);

      let tempResource = { ...selectedActivationResource };
      if (selectedActivationResource.targetTypeId === "EMAIL") {
        tempResource.targetAddress = e.target.value;
      } else if (selectedActivationResource.targetTypeId === "REST_ENDPOINT") {
        if (e.target.name === "URL") {
          tempResource.targetAddress = e.target.value;
        } else {
          tempResource.targetAddress = "";
        }
      } else {
        tempResource.targetAddress = "";
      }
      setSelectedActivation(tempResource);
    } else if (type === "SUSPEND") {
      let tempData = { ...suspendConnectionFields };
      tempData[e.target.name] = e.target.value;
      setSuspendFields(tempData);

      let tempResource = { ...selectedSuspendResource };
      if (selectedSuspendResource.targetTypeId === "EMAIL") {
        tempResource.targetAddress = e.target.value;
      } else if (selectedSuspendResource.targetTypeId === "REST_ENDPOINT") {
        if (e.target.name === "URL") {
          tempResource.targetAddress = e.target.value;
        } else {
          tempResource.targetAddress = "";
        }
      } else {
        tempResource.targetAddress = "";
      }
      setSelectedSuspend(tempResource);
    } else if (type === "RESUME") {
      let tempData = { ...resumeConnectionFields };
      tempData[e.target.name] = e.target.value;
      setResumeFields(tempData);

      let tempResource = { ...selectedResumeResource };
      if (selectedResumeResource.targetTypeId === "EMAIL") {
        tempResource.targetAddress = e.target.value;
      } else if (selectedResumeResource.targetTypeId === "REST_ENDPOINT") {
        if (e.target.name === "URL") {
          tempResource.targetAddress = e.target.value;
        } else {
          tempResource.targetAddress = "";
        }
      } else {
        tempResource.targetAddress = "";
      }
      setSelectedResume(tempResource);
    } else if (type === "QUALIFICATION") {
      let tempData = { ...connectionFields };
      tempData[e.target.name] = e.target.value;
      setConnectionFields(tempData);

      let tempResource = { ...selectedResource };
      if (selectedResource.targetTypeId === "EMAIL") {
        tempResource.targetAddress = e.target.value;
      } else if (selectedResource.targetTypeId === "REST_ENDPOINT") {
        if (e.target.name === "URL") {
          tempResource.targetAddress = e.target.value;
        } else {
          tempResource.targetAddress = "";
        }
      } else {
        tempResource.targetAddress = "";
      }
      setSelectedResource(tempResource);
    }
  };

  const updateTableFields = (i, e, type) => {
    if (type === "FULFILMENT") {
      let tempData = [...fulfilmentTableFields];
      tempData[i][e.target.name] = e.target.value;
      if (e.target.name === "label") {
        tempData[i].name = setCamelCase(e.target.value);
      }
      setFulfilmentTableFields(tempData);
    } else if (type === "ACTIVATION") {
      let tempData = [...activationTableFields];
      tempData[i][e.target.name] = e.target.value;
      if (e.target.name === "label") {
        tempData[i].name = setCamelCase(e.target.value);
      }
      setActivationTableFields(tempData);
    } else if (type === "SUSPEND") {
      let tempData = [...suspendTableFields];
      tempData[i][e.target.name] = e.target.value;
      if (e.target.name === "label") {
        tempData[i].name = setCamelCase(e.target.value);
      }
      setSuspendTableFields(tempData);
    } else if (type === "RESUME") {
      let tempData = [...resumeTableFields];
      tempData[i][e.target.name] = e.target.value;
      if (e.target.name === "label") {
        tempData[i].name = setCamelCase(e.target.value);
      }
      setResumeTableFields(tempData);
    } else if (type === "QUALIFICATION") {
      let tempData = [...tableFields];
      tempData[i][e.target.name] = e.target.value;
      if (e.target.name === "label") {
        tempData[i].name = setCamelCase(e.target.value);
      }
      setTableFields(tempData);
    }
  };

  const setCamelCase = (str) => {
    return str
      .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
      })
      .replace(/\s+/g, "");
  };

  const [activationFile, setActivationFileName] = useState("");
  const onActivationFileChange = (e) => {
    let file = e.target.files[0];
    setActivationFileName(e.target.files[0].name);
    const reader = new FileReader();
    let jsonContent = "";
    reader.readAsText(file);
    reader.onload = function () {
      jsonContent = reader.result;
      let jsonObject = JSON.parse(jsonContent);
      var url = jp.query(jsonObject, "$..servers[0].url");
      var allrefs = jp.query(jsonObject, "$..post..schema");
      let post_schemas = allrefs;
      let refSchema = post_schemas[0].$ref;
      var pieces = refSchema.split(/[\s\/]+/);
      var postParameters = jp.query(
        jsonObject,
        "$.components.schemas." + pieces[pieces.length - 1] + ".properties",
      );
      let connectionFields = { ...activationConnectionFields };
      connectionFields.URL = url[0];
      setActivationFields(connectionFields);
      let localSelectedRes = { ...selectedActivationResource };
      localSelectedRes.targetAddress = connectionFields.URL;
      setSelectedActivation(localSelectedRes);

      for (var i = 0; i < postParameters.length; i++) {
        let tempData = [...activationTableFields];
        for (const [key, value] of Object.entries(postParameters[i])) {
          let obj = {
            label: value.label,
            name: setCamelCase(key),
            type: value.type,
            validation: value.validation,
          };
          tempData.push(obj);
        }
        if (postParameters.length === i + 1) {
          setActivationTableFields(tempData);
        }
      }
    };
  };

  const activationFileData = (e) => { };

  const addNewRow = (type) => {
    let obj = {
      name: "",
      type: "string",
      label: "",
      validation: "",
    };
    if (type === "FULFILMENT") {
      let tempData = [...fulfilmentTableFields];
      tempData.push(obj);
      setFulfilmentTableFields(tempData);
    } else if (type === "ACTIVATION") {
      let tempData = [...activationTableFields];
      tempData.push(obj);
      setActivationTableFields(tempData);
    } else if (type === "SUSPEND") {
      let tempData = [...suspendTableFields];
      tempData.push(obj);
      setSuspendTableFields(tempData);
    } else if (type === "RESUME") {
      let tempData = [...resumeTableFields];
      tempData.push(obj);
      setResumeTableFields(tempData);
    } else if (type === "QUALIFICATION") {
      let tempData = [...tableFields];
      tempData.push(obj);
      setTableFields(tempData);
    }
  };

  const removeRow = (type, index) => {
    if (type === "FULFILMENT") {
      let tempData = [...fulfilmentTableFields];
      tempData.splice(index, 1);
      setFulfilmentTableFields(tempData);
    } else if (type === "ACTIVATION") {
      let tempData = [...activationTableFields];
      tempData.splice(index, 1);
      setActivationTableFields(tempData);
    } else if (type === "SUSPEND") {
      let tempData = [...suspendTableFields];
      tempData.splice(index, 1);
      setSuspendTableFields(tempData);
    } else if (type === "RESUME") {
      let tempData = [...resumeTableFields];
      tempData.splice(index, 1);
      setResumeTableFields(tempData);
    } else if (type === "QUALIFICATION") {
      let tempData = [...tableFields];
      tempData.splice(index, 1);
      setTableFields(tempData);
    }
  };

  const submitData = (releaseAction) => {
    let componentData = JSON.parse(JSON.stringify({ ...data }));
    setCustomAttributeError({
      error: "",
      show: false,
    });
    var tempEnrichmentConfig = {
      purchaseable: "",
      removeable: "",
      rePurchaseable: "",
      visible: "",
    };

    // validate and fix price decimal start
    componentData.price = Number(componentData.price).toFixed(2) + "";
    if (componentData.variants && componentData.variants.length > 0) {
      for (var i = 0; i < componentData.variants.length; i++) {
        componentData.variants[i].price =
          Number(componentData.variants[i].price).toFixed(2) + "";
        if (
          componentData.variants[i].otherPrices &&
          componentData.variants[i].otherPrices.length > 0
        ) {
          for (
            var j = 0;
            j < componentData.variants[i].otherPrices.length;
            j++
          ) {
            componentData.variants[i].otherPrices[j].price =
              Number(componentData.variants[i].otherPrices[j].price).toFixed(
                2,
              ) + "";
          }
        }
      }
    }
    if (componentData.otherPrices && componentData.otherPrices.length > 0) {
      for (var c = 0; c < componentData.otherPrices.length; c++) {
        componentData.otherPrices[c].price =
          Number(componentData.otherPrices[c].price).toFixed(2) + "";
      }
    }
    // validate and fix price decimal end

    if (
      componentData.enrichmentConfig &&
      componentData.enrichmentConfig.length > 0
    ) {
      for (var i = 0; i < componentData.enrichmentConfig.length; i++) {
        tempEnrichmentConfig.purchaseable +=
          (i > 0 ? "," : "") +
          componentData.enrichmentConfig[i].id +
          ":" +
          (componentData.enrichmentConfig[i].purchaseable
            ? componentData.enrichmentConfig[i].purchaseable
            : false);
        tempEnrichmentConfig.removeable +=
          (i > 0 ? "," : "") +
          componentData.enrichmentConfig[i].id +
          ":" +
          (componentData.enrichmentConfig[i].removeable
            ? componentData.enrichmentConfig[i].removeable
            : false);
        tempEnrichmentConfig.rePurchaseable +=
          (i > 0 ? "," : "") +
          componentData.enrichmentConfig[i].id +
          ":" +
          (componentData.enrichmentConfig[i].rePurchaseable
            ? componentData.enrichmentConfig[i].rePurchaseable
            : false);
        tempEnrichmentConfig.visible +=
          (i > 0 ? "," : "") +
          componentData.enrichmentConfig[i].id +
          ":" +
          (componentData.enrichmentConfig[i].visible
            ? componentData.enrichmentConfig[i].visible
            : false);
      }
    }
    if (componentData.variants && componentData.variants.length > 0) {
      componentData.variants.forEach((x) => delete x.priceOptions);
    }
    if (releaseAction) {
      componentData.releaseAction = releaseAction;
    }
    componentData.physical = componentData.physical;
    componentData.inventoried = componentData.inventoried;
    componentData.rawMaterial = componentData.rawMaterial;
    componentData.sellable = componentData.sellable;
    componentData.componentType = props.componentType;
    componentData.enrichmentConfig = tempEnrichmentConfig;
    if (componentData.priceType !== "NTC" && componentData.priceType !== "RC") {
      delete componentData.priceTenure;
      delete componentData.priceTenureUOM;
    }
    // else if (componentData.priceType === 'RC') {
    //     if (componentData.priceTenureUOM === 'TF_qtr') {
    //         componentData.priceTenure = '3';
    //         componentData.priceTenureUOM = 'TF_mon';
    //     } else {
    //         componentData.priceTenure = '1';
    //     }
    // }
    else {
      componentData.priceTenure = +componentData.priceTenure;
    }

    if (props.addComponentType === "assembly") {
      let checkTaskTitle = false;
      let routinTaskIndex = componentData.routing.routingTasks.length;
      while (routinTaskIndex--) {
        if (
          componentData.routing.routingTasks[routinTaskIndex].name === "" &&
          componentData.routing.routingTasks[routinTaskIndex].description ===
          "" &&
          componentData.routing.routingTasks[routinTaskIndex]
            .estimatedCompletionTimeInSeconds === ""
        ) {
          componentData.routing.routingTasks.splice(routinTaskIndex, 1);
        } else {
          if (
            componentData.routing.routingTasks[routinTaskIndex].name !== "" ||
            componentData.routing.routingTasks[routinTaskIndex].description !==
            "" ||
            componentData.routing.routingTasks[routinTaskIndex]
              .estimatedCompletionTimeInSeconds !== ""
          ) {
            checkTaskTitle = true;
            let obj = componentData.routing.routingTasks[routinTaskIndex];
            for (let item in obj) {
              if (!obj[item]) {
                let errorObj = {
                  name:
                    item === "estimatedCompletionTimeInSeconds" ? "time" : item,
                  row: routinTaskIndex + 1,
                };
                props.setErrorMessage(
                  t("ROUTING_TASK_ERROR", { errorObj }),
                  false,
                );
                return;
              }
            }
          }
        }
      }
      // for (let i = 0; i < componentData.routing.routingTasks.length; i++) {
      //     if (componentData.routing.routingTasks[i].name === '' &&
      //         componentData.routing.routingTasks[i].description === '' &&
      //         componentData.routing.routingTasks[i].estimatedCompletionTimeInSeconds === '') {
      //         componentData.routing.routingTasks.splice(i, 1);
      //     } else {
      //         if (componentData.routing.routingTasks[i].name !== '' ||
      //             componentData.routing.routingTasks[i].description !== '' ||
      //             componentData.routing.routingTasks[i].estimatedCompletionTimeInSeconds !== '') {
      //             checkTaskTitle = true;
      //             let obj = componentData.routing.routingTasks[i];
      //             for (let item in obj) {
      //                 if (!obj[item]) {
      //                     let errorObj = {
      //                         name: item === 'estimatedCompletionTimeInSeconds' ? 'time' : item,
      //                         row: i + 1
      //                     }
      //                     props.setErrorMessage(t('ROUTING_TASK_ERROR', { errorObj }), false);
      //                     return;
      //                 }
      //             }
      //         }
      //     }
      // }
      if (checkTaskTitle) {
        if (!componentData.routing.name) {
          props.setErrorMessage(t("ROUTING_TITLE_ERROR"), false);
          return;
        }
      }
    }

    componentData.provisioning = {};
    if (selectedFulfilmentResource.resourceId) {
      componentData.provisioning.resourceId =
        selectedFulfilmentResource.resourceId
          ? selectedFulfilmentResource.resourceId
          : "";
      componentData.provisioning.providerId =
        selectedFulfilmentResource.providerId
          ? selectedFulfilmentResource.providerId
          : "";
      componentData.provisioning.targetTypeId =
        selectedFulfilmentResource.targetTypeId
          ? selectedFulfilmentResource.targetTypeId
          : "";
      componentData.provisioning.targetAddress =
        selectedFulfilmentResource.targetAddress
          ? selectedFulfilmentResource.targetAddress
          : "";

      componentData.provisioning.extraFields = fulfilmentConnectionFields;
      let tempFulfilmentTableFields = [];
      for (let i = 0; i < fulfilmentTableFields.length; i++) {
        if (fulfilmentTableFields[i].label) {
          tempFulfilmentTableFields.push(fulfilmentTableFields[i]);
        }
      }
      componentData.provisioning.parameters = fulfilmentTableFields
        ? JSON.stringify(tempFulfilmentTableFields)
        : "";
    }
    componentData.activation = {};
    if (selectedActivationResource.resourceId) {
      componentData.activation.resourceId =
        selectedActivationResource.resourceId
          ? selectedActivationResource.resourceId
          : "";
      componentData.activation.providerId =
        selectedActivationResource.providerId
          ? selectedActivationResource.providerId
          : "";
      componentData.activation.targetTypeId =
        selectedActivationResource.targetTypeId
          ? selectedActivationResource.targetTypeId
          : "";
      componentData.activation.targetAddress =
        selectedActivationResource.targetAddress
          ? selectedActivationResource.targetAddress
          : "";

      componentData.activation.extraFields = activationConnectionFields;
      let tempActivationTableFields = [];
      for (let i = 0; i < activationTableFields.length; i++) {
        if (activationTableFields[i].label) {
          tempActivationTableFields.push(activationTableFields[i]);
        }
      }
      componentData.activation.parameters = activationTableFields
        ? JSON.stringify(tempActivationTableFields)
        : "";
    }
    componentData.suspendResource = {};
    if (data.priceType === "RC") {
      if (selectedSuspendResource.resourceId) {
        componentData.suspendResource.resourceId =
          selectedSuspendResource.resourceId
            ? selectedSuspendResource.resourceId
            : "";
        componentData.suspendResource.providerId =
          selectedSuspendResource.providerId
            ? selectedSuspendResource.providerId
            : "";
        componentData.suspendResource.targetTypeId =
          selectedSuspendResource.targetTypeId
            ? selectedSuspendResource.targetTypeId
            : "";
        componentData.suspendResource.targetAddress =
          selectedSuspendResource.targetAddress
            ? selectedSuspendResource.targetAddress
            : "";

        componentData.suspendResource.extraFields = suspendConnectionFields;
        let tempSuspendTableFields = [];
        for (let i = 0; i < suspendTableFields.length; i++) {
          if (suspendTableFields[i].label) {
            tempSuspendTableFields.push(suspendTableFields[i]);
          }
        }
        componentData.suspendResource.parameters = suspendTableFields
          ? JSON.stringify(tempSuspendTableFields)
          : "";
      }
      componentData.resumeResource = {};
      if (selectedResumeResource.resourceId) {
        componentData.resumeResource.resourceId =
          selectedResumeResource.resourceId
            ? selectedResumeResource.resourceId
            : "";
        componentData.resumeResource.providerId =
          selectedResumeResource.providerId
            ? selectedResumeResource.providerId
            : "";
        componentData.resumeResource.targetTypeId =
          selectedResumeResource.targetTypeId
            ? selectedResumeResource.targetTypeId
            : "";
        componentData.resumeResource.targetAddress =
          selectedResumeResource.targetAddress
            ? selectedResumeResource.targetAddress
            : "";

        componentData.resumeResource.extraFields = resumeConnectionFields;
        let tempResumeTableFields = [];
        for (let i = 0; i < resumeTableFields.length; i++) {
          if (resumeTableFields[i].label) {
            tempResumeTableFields.push(resumeTableFields[i]);
          }
        }
        componentData.resumeResource.parameters = resumeTableFields
          ? JSON.stringify(tempResumeTableFields)
          : "";
      }
    }
    if (componentData.sellable) {
      componentData.basicDetail.productName = componentData.name;
      componentData.basicDetail.productDescription = componentData.description;
      componentData.basicDetail.startingPrice = componentData.price;
      componentData.basicDetail.overrideStartingPrice = false;
    } else {
      delete componentData.basicDetail;
      delete componentData.orderApproval;
      delete componentData.billingTriggerPhase;
    }
    if (
      componentData.customAttributes &&
      componentData.customAttributes.length > 0
    ) {
      for (var i = 0; i < componentData.customAttributes.length; i++) {
        if (componentData.customAttributes[i].valueType !== "boolean") {
          if (!componentData.customAttributes[i].attrValue) {
            if (componentData.customAttributes[i].required) {
              setCustomAttributeError({
                error: componentData.customAttributes[i].attrName,
                show: true,
              });
              return;
            } else {
              // componentData.customAttributes.splice(i, 1);
            }
          }
        }
      }
    }
    componentData.customer = [...customersList];
    delete componentData.hasVariants;
    if (selectedSuspendResource.resourceId) {
      if (selectedResumeResource.resourceId) {
        props.closeDialog(componentData);
      } else {
        props.setErrorMessage(t("RESUME_RESOURCE_ERROR"), false);
      }
    } else {
      props.closeDialog(componentData);
    }
  };

  const addVariantRow = () => {
    setErr({
      ...err,
      price: "",
    });
    let tempData = { ...data };
    tempData.price = "0.00";
    tempData.variants.push({
      name: "",
      price: "",
      description: "",
      featureCode: "",
      priceOptions: props.allOtherPricesList,
    });
    setData(tempData);
  };

  const removeVariant = (e, variantIndex) => {
    let tempData = { ...data };
    if (tempData.variants[variantIndex].productId) {
      // setLoading(true);
      // BusApiCall('DELETE', `${constants.busV4Url}/components/products/${tempData.variants[variantIndex].productId}`).then(res => {
      //     if (res.data.productId) {
      //         if (tempData.variants[variantIndex].productId) {
      //             tempData.variants.push({
      //                 name: '',
      //                 price: '',
      //                 description: '',
      //                 featureCode: '',
      //                 deleteId: tempData.variants[variantIndex].productId
      //             })
      //         }
      //         tempData.variants.splice(variantIndex, 1);
      //         setData(tempData);
      //         setLoading(false);
      //     }

      // }).catch(err => {
      //     setLoading(false);
      //     if (err.response && err.response.data && err.response.data.message) {
      //         props.setErrorMessage(err.response.data.message, false)
      //     } else {
      //         props.setErrorMessage(this.props.t('DEFAULT_ERROR_MESSAGE'), false)
      //     }
      // })
      tempData.variants[variantIndex].deleteId =
        tempData.variants[variantIndex].productId;
      delete tempData.variants[variantIndex].productId;
      setData(tempData);
    } else {
      tempData.variants.splice(variantIndex, 1);
      setData(tempData);
    }
  };

  const onVariantChange = (e, variantIndex) => {
    let error = {};
    let tempData = { ...data };
    if (e.target.value !== " ") {
      if (e.target.name === "name" && e.target.value.length > 100) {
        error.variantName = t("MAX_100_CHARACTER_ERROR");
        return;
      }
      if (e.target.name === "featureCode" && e.target.value.length > 20) {
        error.featureCode = t("MAX_20_CHARACTER_ERROR");
        return;
        // props.setErrorMessage(t('MAX_100_CHARACTER_ERROR'), false)
      }
      if (e.target.name === "price") {
        if (e.target.value >= 0) {
          let t = e.target.value;
          tempData.variants[variantIndex][e.target.name] = e.value =
            t.indexOf(".") >= 0
              ? t.substr(0, t.indexOf(".")) + t.substr(t.indexOf("."), 3)
              : t;
        } else {
          tempData[e.target.name] = 0;
        }
      } else {
        tempData.variants[variantIndex][e.target.name] = e.target.value;
      }
      setErr(error);
      setData(tempData);
    }
  };

  const checkUploadedFile = (file) => {
    setError({
      key: "",
      show: false,
    });
    setLoading(true);
    let fileReader = new FileReader();
    if (file.length > 1) {
      file = file.splice(file.length - 1, 1);
    }
    fileReader.readAsText(file[0]);
    fileReader.onload = (event) => {
      if (
        /^[\],:{}\s]*$/.test(
          event.target.result
            .replace(/\\["\\\/bfnrtu]/g, "@")
            .replace(
              /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,
              "]",
            )
            .replace(/(?:^|:|,)(?:\s*\[)+/g, ""),
        )
      ) {
        importTemplateData(JSON.parse(event.target.result));
      } else {
        setError({
          key: "Invalid JSON file.",
          show: true,
        });
      }
    };
  };

  const importTemplateData = (data) => {
    let intialData = {
      name: data.name,
      featureCode: data.featureCode,
      description: data.description,
      price: data.price,
      priceType: data.priceType,
      variants: data.variants,
      isPhysical: data.isPhysical,
      isRawMaterial: data.isRawMaterial,
      isInventoried: data.isInventoried,
      sellable: data.sellable,
      priceTenureUOM: data.priceTenureUOM ? data.priceTenureUOM : "TF_day",
      priceTenure: data.priceTenure ? data.priceTenure : 1,
    };
    setData(intialData);
    if (data.provisioning) {
      for (var i = 0; i < props.provisioningResources.length; i++) {
        if (
          props.provisioningResources[i].resourceId ===
          data.provisioning.resourceId
        ) {
          setSelectedFulfilment(props.provisioningResources[i]);
        }
      }
      if (data.provisioning.extraFields) {
        setFulfilmentFields(data.provisioning.extraFields);
      }
      if (data.provisioning.parameters) {
        setFulfilmentTableFields(JSON.parse(data.provisioning.parameters));
      }
      if (data.provisioning.paramsUpdatable) {
        setFulfilmentTableEditable(data.provisioning.paramsUpdatable);
      }
      if ("STD_VM_PROV" === data.provisioning.resourceId) {
        setShowDefaultValue(true);
      }
    }
    if (data.activation) {
      for (var i = 0; i < props.activationResources.length; i++) {
        if (
          props.activationResources[i].resourceId === data.activation.resourceId
        ) {
          setSelectedActivation(props.activationResources[i]);
        }
      }
      if (data.activation.extraFields) {
        setActivationFields(data.activation.extraFields);
      }
      if (data.activation.parameters) {
        setActivationTableFields(JSON.parse(data.activation.parameters));
      }
      if (data.activation.paramsUpdatable) {
        setActivationTableEditable(data.activation.paramsUpdatable);
      }
    }

    if (data.suspendResource) {
      for (var i = 0; i < props.suspendResources.length; i++) {
        if (
          props.suspendResources[i].resourceId ===
          data.suspendResource.resourceId
        ) {
          setSelectedSuspend(props.suspendResources[i]);
        }
      }
      if (data.suspendResource.extraFields) {
        setSuspendFields(data.suspendResource.extraFields);
      }
      if (data.suspendResource.parameters) {
        setSuspendTableFields(JSON.parse(data.suspendResource.parameters));
      }
      if (data.suspendResource.paramsUpdatable) {
        setSuspendTableEditable(data.suspendResource.paramsUpdatable);
      }
    }

    if (data.resumeResource) {
      for (var i = 0; i < props.resumeResources.length; i++) {
        if (
          props.resumeResources[i].resourceId === data.resumeResource.resourceId
        ) {
          setSelectedResume(props.resumeResources[i]);
        }
      }
      if (data.resumeResource.extraFields) {
        setResumeFields(data.resumeResource.extraFields);
      }
      if (data.resumeResource.parameters) {
        setResumeTableFields(JSON.parse(data.resumeResource.parameters));
      }
      if (data.resumeResource.paramsUpdatable) {
        setResumeTableEditable(data.resumeResource.paramsUpdatable);
      }
    }
    setLoading(false);
  };

  const onFilesError = (error, file) => {
    console.log("error code " + error.code + ": " + error.message);
  };

  const [importComponentModal, setImportComponent] = useState(false);
  const addKitItem = () => {
    setImportComponent(true);
  };

  const importComponent = (val) => {
    let tempData = { ...data };
    if (val) {
      if (tempData.children) {
        for (var i = 0; i < tempData.children.length; i++) {
          if (tempData.children[i].id === val.id) {
            props.setErrorMessage(t("COMPONENT_ALREADY_EXISTS_IN_KIT"), false);
            setImportComponent(false);
            return;
          }
        }
      }
      let compData = {
        id: val.id,
        name: val.name,
        componentType: val.componentType,
        featureCode: val.featureCode,
        description: val.description,
        price: val.price,
        priceType: val.priceType,
        expandKitComponents: false,
        add: true,
        presetQuantity: "1",
        priceTenureUOM: val.priceTenureUOM ? val.priceTenureUOM : "TF_day",
        priceTenure: val.priceTenure ? val.priceTenure : 1,
      };
      if (val.assembly) {
        compData.children = val.children;
      }
      if (!tempData.children) {
        tempData.children = [];
      }
      tempData.children.push({ ...compData });
      setData(tempData);
      setImportComponent(false);
    } else {
      setImportComponent(false);
    }
  };

  const expandKitComponentsTable = (event, row, value) => {
    let tempData = { ...data };
    for (var i = 0; i < tempData.children.length; i++) {
      if (tempData.children[i].id === row.id) {
        tempData.children[i].expandKitComponents = value;
        setData(tempData);
        break;
      }
    }
  };

  const [showDeleteKitComponent, setDeleteKitDialog] = useState(false);
  const [kitToRemove, setKitToRemove] = useState({});

  const removeKit = (event, row) => {
    setKitToRemove(row);
    setDeleteKitDialog(true);
  };

  const closeDeleteKitComponent = (val) => {
    if (val) {
      // remove kit
      let tempData = { ...data };
      for (var i = 0; i < tempData.children.length; i++) {
        if (tempData.children[i].id === kitToRemove.id) {
          // If kit added in data but not submited
          if (tempData.children[i].add) {
            tempData.children.splice(i, 1);
          } else {
            // If kit is submited and fetched from the API
            tempData.children[i].remove = true;
          }
          setData(tempData);
          setKitToRemove({});
          setDeleteKitDialog(false);
          break;
        }
      }
    } else {
      setKitToRemove({});
      setDeleteKitDialog(false);
    }
  };

  const addInstruction = () => {
    let tempData = { ...data };
    let instruction = {
      name: "",
      sequenceNum: tempData.routing.routingTasks.length + 1,
      description: "",
      estimatedCompletionTimeInSeconds: "",
    };
    tempData.routing.routingTasks.push(instruction);
    setData(tempData);
  };

  const onInstructionChange = (e, index) => {
    setUnsavedChangesWarning(true);
    let tempData = { ...data };
    if (e.target.name === "estimatedCompletionTimeInSeconds") {
      var reg = /^\d+$/;
      if (e.target.value === "" || reg.test(e.target.value)) {
        tempData.routing.routingTasks[index][e.target.name] = e.target.value;
      }
    } else {
      tempData.routing.routingTasks[index][e.target.name] = e.target.value;
    }
    setData(tempData);
  };

  const removeInstruction = (index) => {
    let tempData = { ...data };
    for (var i = 0; i < tempData.routing.routingTasks.length; i++) {
      if (i > index) {
        tempData.routing.routingTasks[i].sequenceNum =
          tempData.routing.routingTasks[i].sequenceNum - 1;
      }
    }
    tempData.routing.routingTasks.splice(index, 1);
    tempData.routing.routingTasks.sort((a, b) =>
      a && b ? a.sequenceNum - b.sequenceNum : 0,
    );
    setData(tempData);
  };

  const changeInstructionSequence = (dir, index) => {
    let tempData = { ...data };
    if (dir === "up") {
      if (tempData.routing.routingTasks[index].sequenceNum > 1) {
        tempData.routing.routingTasks[index - 1].sequenceNum =
          tempData.routing.routingTasks[index - 1].sequenceNum + 1;
        tempData.routing.routingTasks[index].sequenceNum =
          tempData.routing.routingTasks[index].sequenceNum - 1;
      }
    } else {
      tempData.routing.routingTasks[index + 1].sequenceNum =
        tempData.routing.routingTasks[index + 1].sequenceNum - 1;
      tempData.routing.routingTasks[index].sequenceNum =
        tempData.routing.routingTasks[index].sequenceNum + 1;
    }
    tempData.routing.routingTasks.sort((a, b) =>
      a && b ? a.sequenceNum - b.sequenceNum : 0,
    );
    setData(tempData);
  };

  const onChangeRoutingData = (e) => {
    setUnsavedChangesWarning(true);
    let tempData = { ...data };
    tempData.routing[e.target.name] = e.target.value;
    setData(tempData);
  };

  const changeChildrenData = (e, index) => {
    if (e.target.value === "" || e.target.value > 0) {
      let tempData = { ...data };
      tempData.children[index][e.target.name] = e.target.value;
      tempData.children[index].edit = true;
      setData(tempData);
    }
  };

  const setMinQuantityValue = (e, index) => {
    if (e.target.value === 0 || e.target.value === "") {
      let tempData = { ...data };
      tempData.children[index][e.target.name] = 1;
      tempData.children[index].edit = true;
      setData(tempData);
    }
  };

  const toDataUrl = (url) => {
    return new Promise((resolve, reject) => {
      var xhr = new XMLHttpRequest();
      xhr.onload = function () {
        var reader = new FileReader();
        reader.onloadend = function () {
          resolve(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.onerror = reject;
      xhr.open("GET", url);
      xhr.responseType = "blob";
      xhr.send();
    });
  };

  // pre-qual fields
  const [selectedResource, setSelectedResource] = useState({});
  const [connectionFields, setConnectionFields] = useState({});
  const [tableFields, setTableFields] = useState([]);
  const [tableEditable, setTableEditable] = useState(false);
  const [uploadedFile, setUploadedFileName] = useState("");

  const onuploadedFileChange = (e) => {
    let file = e.target.files[0];
    if (file.type === "application/json") {
      setUploadedFileName(e.target.files[0].name);
      const reader = new FileReader();
      let jsonContent = "";
      reader.readAsText(file);
      reader.onload = function () {
        jsonContent = reader.result;
        let jsonObject = JSON.parse(jsonContent);
        var url = jp.query(jsonObject, "$..servers[0].url");
        var allrefs = jp.query(jsonObject, "$..post..schema");
        let post_schemas = allrefs;
        let refSchema = post_schemas[0].$ref;
        var pieces = refSchema.split(/[\s\/]+/);
        var postParameters = jp.query(
          jsonObject,
          "$.components.schemas." + pieces[pieces.length - 1] + ".properties",
        );
        let connectionFields = { ...connectionFields };
        connectionFields.URL = url[0];
        setConnectionFields(connectionFields);
        let localSelectedRes = { ...selectedResource };
        localSelectedRes.targetAddress = connectionFields.URL;
        setSelectedResource(localSelectedRes);

        for (var i = 0; i < postParameters.length; i++) {
          let tempData = [...tableFields];
          for (const [key, value] of Object.entries(postParameters[i])) {
            let obj = {
              label: value.label,
              name: setCamelCase(key),
              type: value.type,
              validation: value.validation,
            };
            tempData.push(obj);
          }
          if (postParameters.length === i + 1) {
            setTableFields(tempData);
          }
        }
      };
    } else {
      props.setErrorMessage(t("INVALID_FILE_FORMAT"), false);
    }
  };

  const [mode, setMode] = useState("add");
  const [editObject, setEditObject] = useState({});
  const addPreQual = () => {
    var prequalData = {};
    if (selectedResource.resourceId) {
      prequalData.resourceId = selectedResource.resourceId
        ? selectedResource.resourceId
        : "";
      prequalData.providerId = selectedResource.providerId
        ? selectedResource.providerId
        : "";
      prequalData.targetTypeId = selectedResource.targetTypeId
        ? selectedResource.targetTypeId
        : "";
      prequalData.targetAddress = selectedResource.targetAddress
        ? selectedResource.targetAddress
        : "";

      prequalData.extraFields = connectionFields;
      let temptableFields = [];
      for (let i = 0; i < tableFields.length; i++) {
        if (tableFields[i].label) {
          temptableFields.push(tableFields[i]);
        }
      }
      prequalData.parameters = tableFields
        ? JSON.stringify(temptableFields)
        : "";

      if (mode === "add") {
        var tempData = { ...data };
        tempData.preQuals.push(prequalData);
        setData(tempData);
      } else {
        var tempData = { ...data };
        tempData.preQuals[editObject.index] = prequalData;
        setData(tempData);
      }
      setSelectedResource({});
      setConnectionFields({});
      setTableFields([]);
      setUploadedFileName("");
      setTableEditable(false);
    }
  };

  const editPreQual = (object, index) => {
    object.index = index;
    setMode("edit");
    setEditObject(object);
    let connectionFields = {};
    let parameters = [];
    let paramsUpdatable = false;
    let orginalResource = props.preQualResourcesList.find(
      (x) => x.resourceId === object.resourceId,
    );
    if (object) {
      if (
        orginalResource.connectionFields &&
        orginalResource.connectionFields.length > 0
      ) {
        orginalResource.connectionFields.map((field, i) => {
          connectionFields[field] = object.extraFields[field];
        });
      }
      if (object.parameters && object.parameters !== null) {
        parameters = JSON.parse(object.parameters);
      }
      paramsUpdatable = orginalResource.paramsUpdatable
        ? orginalResource.paramsUpdatable
        : false;
      object.resourceName = orginalResource.resourceName;
    } else {
      object = {};
    }
    setSelectedResource(object);
    setConnectionFields(connectionFields);
    setTableFields(parameters);
    setTableEditable(paramsUpdatable);
  };

  const deletePreQual = (index) => {
    var tempData = { ...data };
    tempData.preQuals.splice(index, 1);
    setData(tempData);
  };

  const cancelEdit = () => {
    setMode("add");
    setSelectedResource({});
    setConnectionFields({});
    setTableFields([]);
    setUploadedFileName("");
    setTableEditable(false);
  };

  const [tempSelectedAttribute, setTempSelectedAttribute] = useState({});
  const selectAttribute = (e, value) => {
    setTempSelectedAttribute(e);
  };

  const addAssignedProductSpecData = (formData) => {
    const tempData = { ...data };
    if (formData.action === "DELETE") {
      // Store product ID with delete action
      tempData.unassignSpec = {
        productId: formData.productId,
        action: "DELETE",
      };
      setData(tempData);
    } else {
      if (formData && formData.specId) {
        var transformPayload = formData.productSpecCharacteristic.map(toApi);
        const assignedSpec = {
          productId: formData.productId,
          specId: formData.specId,
          productSpecCharacteristic: transformPayload,
          action: "CREATE",
        };

        // Push to assigned specs list in main data object
        if (!tempData.assignedSpecs) {
          tempData.assignedSpecs = {};
        }

        tempData.assignedSpecs = assignedSpec;

        // Update the state
        setData(tempData);
      }
    }
  };
  const storeApplData = (formData) => {
    console.log("-------formData-------", formData);
    addAssignedProductSpecData(formData);
  };
  const displaySaveCharacteristicMessage = (val) => {
    setShowSaveCharacteristicMessage(val);
  };
  const addAttribute = () => {
    if (tempSelectedAttribute.attrName) {
      var tempData = { ...data };
      var selectedattribute = tempSelectedAttribute;
      if (props.mode === "edit") {
        selectedattribute.create = true;
      }
      tempData.customAttributes.push(selectedattribute);
      var tempList = [...customAttributesList];
      var index = tempList.findIndex(
        (x) => x.attrName === tempSelectedAttribute.attrName,
      );
      if (index > -1) {
        tempList.splice(index, 1);
      }
      setCustomAttributesList(tempList);
      setData(tempData);
      setTempSelectedAttribute({});
    }
  };

  const onChangeAttribute = (e) => {
    setUnsavedChangesWarning(true);
    setCustomAttributeError({
      error: "",
      show: false,
    });
    var tempData = { ...data };
    var index = tempData.customAttributes.findIndex(
      (x) => !x.delete && x.attrName === e.target.name,
    );
    if (index > -1) {
      if (tempData.customAttributes[index].valueType === "boolean") {
        if (tempData.customAttributes[index].attrValue) {
          tempData.customAttributes[index].attrValue = false;
        } else {
          tempData.customAttributes[index].attrValue = true;
        }
      } else {
        tempData.customAttributes[index].attrValue = e.target.value;
      }
      if (tempData.customAttributes[index].productId) {
        tempData.customAttributes[index].update = true;
      }
      setData(tempData);
    }
  };

  function findCustomAttributes(data, componentType) {
    let tempCustomAttributesList = [];

    function recursiveSearch(node) {
      if (node.id === componentType) {
        tempCustomAttributesList.push(node);
      }

      if (node.subCategories) {
        node.subCategories.forEach((subCategory) => {
          recursiveSearch(subCategory);
        });
      }
    }

    data.forEach((item) => {
      recursiveSearch(item);
    });

    return tempCustomAttributesList;
  }

  const removeAttribute = (item) => {
    var tempData = { ...data };
    var index = tempData.customAttributes.findIndex(
      (x) => !x.delete && x.attrName === item.attrName,
    );
    if (index > -1) {
      var tempCustomAttributesList = jp.query(
        props.originalBucketsData,
        '$[?(@.id=="' + props.componentType + '")]',
      );
      var originalAttributes = tempCustomAttributesList[0].customAttributes;
      var orgAttrIndex = originalAttributes.findIndex(
        (x) => x.attrName === item.attrName,
      );
      var opt = {
        attrName: item.attrName,
        required: false,
        valueType: item.valueType,
        options: item.options,
      };
      if (orgAttrIndex > -1) {
        if (opt.valueType === "boolean") {
          opt.attrValue = originalAttributes[orgAttrIndex].attrValue
            ? originalAttributes[orgAttrIndex].attrValue
            : false;
        } else {
          opt.attrValue = originalAttributes[orgAttrIndex].attrValue
            ? originalAttributes[orgAttrIndex].attrValue
            : "";
        }
      } else {
        if (opt.valueType === "boolean") {
          opt.attrValue = false;
        } else {
          opt.attrValue = "";
        }
      }
      var tempCustomAttributesList = [...customAttributesList];
      tempCustomAttributesList.push(opt);
      tempCustomAttributesList = tempCustomAttributesList.sort((a, b) =>
        a && b && a.attrName > b.attrName
          ? 1
          : b.attrName > a.attrName
            ? -1
            : 0,
      );
      setCustomAttributesList(tempCustomAttributesList);
      if (item.productId) {
        tempData.customAttributes[index].delete = true;
        tempData.customAttributes[index].update = false;
        setData(tempData);
      } else {
        tempData.customAttributes.splice(index, 1);
        setData(tempData);
      }
    }
  };
  const [customAttributeError, setCustomAttributeError] = useState({
    show: false,
    error: "",
  });
  const [selectedEnrichmentChannel, selectEnrichmentChannel] = useState("");
  const addEnrichmentRow = () => {
    if (selectedEnrichmentChannel) {
      var row = {
        id: selectedEnrichmentChannel,
        purchaseable: false,
        removeable: false,
        rePurchaseable: false,
        visible: false,
      };
      var tempData = { ...data };
      tempData.enrichmentConfig.push(row);
      setData(tempData);
      selectEnrichmentChannel("");
    }
  };
  const changeEnrichmentRow = (e, index) => {
    var tempData = { ...data };
    tempData.enrichmentConfig[index][e.target.name] =
      !tempData.enrichmentConfig[index][e.target.name];
    setData(tempData);
  };
  const deleteEnrichment = (index) => {
    var tempData = { ...data };
    tempData.enrichmentConfig.splice(index, 1);
    setData(tempData);
  };
  const [loading, setLoading] = useState(false);

  const checkCustomAttribute = () => {
    if (
      "customAttributes" in data &&
      Object.keys(data.customAttributes).length > 0
    ) {
      return true;
    } else {
      return false;
    }
  };
  const [customersList, setCustomerList] = useState([]);
  const [customerListData, setCustomerListData] = useState([]);
  const selectCustomers = (data) => {
    var tempIdList = [...customersList];
    var tempDataList = [...customerListData];
    var tempIndex = tempIdList.findIndex((x) => x === data.partyId);
    if (tempIndex > -1) {
      tempIdList.splice(tempIndex, 1);
      var dataIndex = tempDataList.findIndex((x) => x.partyId === data.partyId);
      if (dataIndex > -1) {
        tempDataList.splice(dataIndex, 1);
      }
    } else {
      tempIdList.push(data.partyId);
      tempDataList.push(data);
    }
    setCustomerList(tempIdList);
    setCustomerListData(tempDataList);
  };

  const [showCustomerDialog, setShowCustomerDialog] = useState(false);

  const setInitalCustomers = (list) => {
    if (list && list.length > 0) {
      var custList = [];
      var custData = [];
      var requests = [];
      for (var i = 0; i < list.length; i++) {
        var jsonData = {};
        var request = BusApiCall(
          "GET",
          `${constants.busV4Url}/myProfile?customerId=${list[i]}`,
          jsonData,
        );
        requests.push(request);
        if (list.length === i + 1) {
          Promise.all(requests).then((res) => {
            for (var r = 0; r < res.length; r++) {
              custList.push(res[r].data.partyId);
              custData.push(res[r].data);
              if (res.length === r + 1) {
                setCustomerList(custList);
                setCustomerListData(custData);
              }
            }
          });
        }
      }
    } else {
      setCustomerList([]);
      setCustomerListData([]);
    }
  };
  const deleteCustomer = (data) => {
    var tempIdList = [...customersList];
    var tempDataList = [...customerListData];
    var tempIndex = tempIdList.findIndex((x) => x === data.partyId);
    if (tempIndex > -1) {
      tempIdList.splice(tempIndex, 1);
      var dataIndex = tempDataList.findIndex((x) => x.partyId === data.partyId);
      if (dataIndex > -1) {
        tempDataList.splice(dataIndex, 1);
      }
    }
    setCustomerList(tempIdList);
    setCustomerListData(tempDataList);
  };
  const handleEditor = () => {
    if (editorRef.current) {
      editorRef.current.save();
    }
  };
  const changeBomProductsData = (parent, item) => {
    var tempData = { ...data };
    if (tempData.bom && tempData.bom.length > 0) {
      tempData.bom.forEach(function iter(a) {
        if (a.id === item.id) {
          if (a.customerViewable) {
            a.customerViewable = !a.customerViewable;
          } else {
            a.customerViewable = true;
          }
        }
        Array.isArray(a.bom) && a.bom.forEach(iter);
      });
    }
    setData(tempData);
  };

  const handleCloseDialog = () => {
    if (unsavedChangesWarning) {
      setOpenUnsavedChangesModal(true);
    } else {
      props.closeDialog();
    }
  };

  const confirmCloseDialog = (val) => {
    if (val) {
      setUnsavedChangesWarning(false);

      // If there's a pending navigation, allow it to proceed
      if (pendingNavigation) {
        console.log("Proceeding with blocked navigation");
        setTimeout(() => {
          history(pendingNavigation.pathname);
        }, 100);
        setPendingNavigation(null);
      }

      props.closeDialog();
    } else {
      setOpenUnsavedChangesModal(false);
      setPendingNavigation(null);
    }
  };

  // const classess = useStyles();
  return (
    <>
      <Dialog
        disableScrollLock={true}
        maxWidth={"lg"}
        fullWidth={true}
        open={importComponentModal}
        aria-labelledby="importKitPaper"
        PaperComponent={ImportKitPaper}
      >
        <DialogTitle id="importKitPaper" style={{ cursor: "move" }}>
          {t("CHOOSE_COMPONENT")}
        </DialogTitle>
        <DialogContent dividers>
          <DialogContentText>
            <ComponentProduct
              screen={"createBom"}
              importComponent={importComponent}
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={(event) => importComponent(false)} color="primary">
            {t("CANCEL")}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        disableScrollLock={true}
        maxWidth={"lg"}
        fullWidth={true}
        open={props.open}
        aria-labelledby="createProductTitle"
        PaperComponent={DraggableResizablePaper} //added draggable and resizable together
      >
        <Loader loading={loading} />
        <DialogTitle id="createProductTitle" style={{ cursor: "move" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <span style={{ display: step === 0 ? "contents" : "inline-flex" }}>
              <>
                {readonlyMode ? (
                  <>{t("VIEW")}</>
                ) : props.mode === "edit" ? (
                  <>{t("EDIT")}</>
                ) : (
                  <> {t("ADD")} </>
                )}
                {data.name ? `: ${data.name}` : ""}&nbsp;
                {/* {step === 0 && t('DETAILS')}
                                {step === 1 && t('PRODUCT_SPECIFICATION')}
                                {step === 2 && t('CUSTOM_ATTRIBUTES')}
                                {step === 3 && t('ENRICHMENT_CONFIG')}
                                {step === 4 && t('FULFILMENT')}
                                {step === 5 &&
                                    // <span>{t('ASSEMBLY_INSTRUCTIONS')} <Button onClick={event => addInstruction()} color="primary" style={{ float: 'right' }}>{t('ADD')}</Button></span>
                                    t('ASSEMBLY_INSTRUCTIONS')
                                }
                                {step === 6 && t('ADDITIONAL_INFO')}
                                {step === 8 && t('HISTORY')}
                                {step === 7 && t('CUSTOMERS')} */}
              </>
            </span>
            {/* {step !== 0 && */}
            <span
              style={{ display: "flex", alignItems: "center", gap: "2rem" }}
            >
              {/* {step === 0 &&
                                    <FormControl variant="outlined" className="custom-select-input" size={'small'} style={{ width: '200px' }}>
                                        <InputLabel id="language" htmlFor="outlined-age-native-simple"> {t('SELECT_LANGUAGE') + ' *'}</InputLabel>
                                        <Select
                                            native
                                            labelId="language"
                                            label='Select Language'
                                            onChange={event => onLanguageChange(event)}
                                            inputProps={{
                                                name: 'language',
                                                id: 'language',
                                            }}
                                        >
                                            <option value="en_US">{t('English')}</option>
                                            <option value="spanish">{t('Spanish')}</option>
                                            <option value="en_FR">{t('French')}</option>
                                        </Select>
                                    </FormControl>
                                } */}
              <Tooltip title={t("CLOSE")}>
                {/* <IconButton edge='end' onTouchStart={event => props.closeDialog()} onClick={event => props.closeDialog()} aria-label="close"> */}
                <IconButton
                  edge="end"
                  onTouchStart={(event) => handleCloseDialog()}
                  onClick={(event) => handleCloseDialog()}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            </span>
            {/* } */}
          </div>
          {/* {step === 0 &&
                    <Files
                        className="files-dropzone"
                        onChange={checkUploadedFile}
                        onError={onFilesError}
                        accepts={[".json"]}
                        maxFileSize={10000000}
                        minFileSize={0}
                        clickable={true}
                        style={{ float: 'right', position: 'relative' }}
                    >
                        <Button>{t('IMPORT_PRODUCT_TEMPLATE')}</Button>
                    </Files>
                } */}
        </DialogTitle>
        <DialogContent style={{ height: "506px" }} dividers>
          <div style={{ marginBottom: "1rem" }}>
            {/* <Stepper activeStep={getCurrentStepIndex()}>
                            {getDynamicSteps().map((stepObj, index) => {
                                return (
                                    <Step key={stepObj.key}>
                                        <StepLabel
                                            onClick={() => changeStep(stepObj.originalStep)}
                                            style={{ cursor: 'pointer' }}
                                        >{stepObj.label}</StepLabel>
                                    </Step>
                                );
                            })}
                        </Stepper> */}
            {/* standardised stepper component */}
            <StepperNew
              activeStep={step}
              steps={getDynamicSteps().map((stepObj) => ({
                label: stepObj.label,
                value: stepObj.originalStep,
              }))}
              onStepSelect={(event, stepValue) => changeStep(stepValue)}
              screen="createPackage"
            />
          </div>
          {step === 0 && (
            <>
              <ComponentForm
                data={data}
                err={err}
                errLocale={errLocale}
                mode={props.mode}
                removeVariant={removeVariant}
                addVariantRow={addVariantRow}
                onVariantChange={onVariantChange}
                onChange={onChangeForm}
                addKitItem={addKitItem}
                addComponentType={props.addComponentType}
                expandKitComponentsTable={expandKitComponentsTable}
                removeKit={removeKit}
                changeChildrenData={changeChildrenData}
                setMinQuantityValue={setMinQuantityValue}
                // sellable product
                categoryList={props.categoryList}
                onChangeBasicDetail={onChangeBasicDetail}
                onImageChange={onImageChange}
                renderImage={renderImage}
                changeBomProductsData={changeBomProductsData}
                readonlyMode={readonlyMode}
                addOtherPrice={addOtherPrice}
                onChangeOtherPrice={onChangeOtherPrice}
                deleteOtherPrice={deleteOtherPrice}
                disableOtherPriceOption={props.disableOtherPriceOption}
                priceOptions={props.priceOptions}
                modules={props.modules}
                addOtherPricesOnVariant={addOtherPricesOnVariant}
                onChangeOtherPriceVariant={onChangeOtherPriceVariant}
                deleteOtherPriceOnVariant={deleteOtherPriceOnVariant}
                isMobile={props.isMobile}
              />
            </>
          )}
          {step === 1 && (
            <EditSpecCharacteristicsAppl
              t={props.t}
              productId={props.editData.id}
              productName={props.editData.name}
              specCategoryList={props.specCategoryList}
              storeApplData={storeApplData}
              readonlyMode={readonlyMode}
              isMobile={props.isMobile}
              showSaveCharacteristicMessage={displaySaveCharacteristicMessage}
              showResponseMessage={showResponseMessage}
            />
          )}
          {step === 2 && (
            <div className="borderOutline roundCorners">
              <CustomAttributes
                list={customAttributesList}
                selectAttribute={selectAttribute}
                data={data.customAttributes}
                addAttribute={addAttribute}
                tempSelectedAttribute={tempSelectedAttribute}
                onChangeAttribute={onChangeAttribute}
                removeAttribute={removeAttribute}
                readonlyMode={readonlyMode}
                isMobile={props.isMobile}
              />
            </div>
          )}
          {step === 3 && (
            <div className="borderOutline roundCorners">
              <EnrichmentConfig
                data={data.enrichmentConfig}
                selectedEnrichmentChannel={selectedEnrichmentChannel}
                addEnrichmentRow={addEnrichmentRow}
                selectEnrichmentChannel={selectEnrichmentChannel}
                onChange={changeEnrichmentRow}
                deleteEnrichment={deleteEnrichment}
                channelList={props.channelList}
                readonlyMode={readonlyMode}
                isMobile={props.isMobile}
              />
            </div>
          )}
          {step === 4 && (
            <>
              <div className="borderOutline roundCorners">
                <ConfigurationResource
                  // provising data
                  provisioningResources={props.provisioningResources}
                  fulfilmentConnectionFields={fulfilmentConnectionFields}
                  fulfilmentTableFields={fulfilmentTableFields}
                  fulfilmentTableEditable={fulfilmentTableEditable}
                  showDefaultValue={showDefaultValue}
                  // activation data
                  activationResources={props.activationResources}
                  activationConnectionFields={activationConnectionFields}
                  activationTableFields={activationTableFields}
                  activationTableEditable={activationTableEditable}
                  activationFileData={activationFileData}
                  onActivationFileChange={onActivationFileChange}
                  activationFile={activationFile}
                  selectResource={selectResource}
                  updateConnectionFields={updateConnectionFields}
                  updateTableFields={updateTableFields}
                  addNewRow={addNewRow}
                  removeRow={removeRow}
                  selectedFulfilmentResource={selectedFulfilmentResource}
                  selectedActivationResource={selectedActivationResource}
                  // Suspend resource
                  suspendResources={props.suspendResources}
                  suspendConnectionFields={suspendConnectionFields}
                  suspendTableFields={suspendTableFields}
                  suspendTableEditable={suspendTableEditable}
                  selectedSuspendResource={selectedSuspendResource}
                  // showDefaultValue={showDefaultValue}

                  // Resume resource
                  resumeResources={props.resumeResources}
                  resumeConnectionFields={resumeConnectionFields}
                  resumeTableFields={resumeTableFields}
                  resumeTableEditable={resumeTableEditable}
                  selectedResumeResource={selectedResumeResource}
                  // showDefaultValue={showDefaultValue}

                  priceType={data.priceType}
                  readonly={props.readonlyMode}
                  isMobile={props.isMobile}
                />
                {/* <Grid item xs={12} md={6}>
                                <PreQualificationModule
                                    preQualResourcesList={props.preQualResourcesList}
                                    connectionFields={connectionFields}
                                    tableFields={tableFields}
                                    tableEditable={tableEditable}
                                    uploadedFile={uploadedFile}
                                    selectedResource={selectedResource}
                                    preQuals={data.preQuals}
                                    mode={mode}

                                    onuploadedFileChange={onuploadedFileChange}
                                    selectResource={selectResource}
                                    updateConnectionFields={updateConnectionFields}
                                    updateTableFields={updateTableFields}
                                    addNewRow={addNewRow}
                                    removeRow={removeRow}

                                    submitData={addPreQual}
                                    editPreQual={editPreQual}
                                    deletePreQual={deletePreQual}
                                    cancelEdit={cancelEdit}
                                    type={'product'}
                                    
                                    readonly={props.readonlyMode}
                                    isMobile={props.isMobile}
                                />
                            </Grid> */}
              </div>
            </>
          )}

          {/* Kit Configuration */}
          {step === 5 && (
            <div className="borderOutline roundCorners">
              <AssemblyInstructions
                data={data}
                onInstructionChange={onInstructionChange}
                removeInstruction={removeInstruction}
                changeInstructionSequence={changeInstructionSequence}
                onChangeRoutingData={onChangeRoutingData}
                addInstruction={addInstruction}
                readonly={props.readonlyMode}
                isMobile={props.isMobile}
              />
            </div>
          )}

          {step === 6 && (
            <AdditionalInfo
              data={data}
              onChangeBasicDetail={onChangeBasicDetail}
              onImageChange={onImageChange}
              save={save}
              onChange={onChangeForm}
              selectedFulfilmentResource={selectedFulfilmentResource}
              selectedActivationResource={selectedActivationResource}
              handleEditor={handleEditor}
              editorRef={editorRef}
              addTermsCond={addTermsCond}
              onChangeTerms={onChangeTerms}
              removeTermAndCond={removeTermAndCond}
              editTermAndCond={editTermAndCond}
              updateTermsCond={updateTermsCond}
              cancelUpdateTermsCond={cancelUpdateTermsCond}
              termsData={termsData}
              termCondToEdit={termCondToEdit}
              readonly={props.readonlyMode}
              isMobile={props.isMobile}
            />
          )}

          {step === 8 && (
            <>
              <div className="borderOutline roundCorners">
                <ComponentComments
                  comments={data.history}
                  onChange={onChangeForm}
                  comment={data.comment}
                  status={data.status}
                  showCommentInput={true}
                  readonly={props.readonlyMode}
                  isMobile={props.isMobile}
                />
              </div>
            </>
          )}

          {step === 7 && (
            <div className="borderOutline roundCorners">
              <ComponentCustomers
                customerData={customersList}
                customerListData={customerListData}
                setShowCustomerDialog={setShowCustomerDialog}
                deleteCustomer={deleteCustomer}
                readonly={props.readonlyMode}
                isMobile={props.isMobile}
              />
            </div>
          )}

          {/* Delete Component dialog */}
          {showDeleteKitComponent && (
            <Dialog
              disableScrollLock={true}
              maxWidth={"sm"}
              fullWidth={true}
              open={showDeleteKitComponent}
              aria-labelledby="delete-dialog-title"
            >
              <DialogTitle id="delete-dialog-title">
                {t("DELETE_KIT_COMPONENT")}
              </DialogTitle>
              <DialogContent dividers>
                <DialogContentText>
                  {t("DELETE_KIT_COMPONENT_MESSAGE", { kitToRemove })}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={(event) => closeDeleteKitComponent(false)}
                  color="primary"
                >
                  {t("CANCEL")}
                </Button>
                <Button
                  onClick={(event) => closeDeleteKitComponent(true)}
                  color="primary"
                >
                  {t("YES")}
                </Button>
              </DialogActions>
            </Dialog>
          )}
        </DialogContent>
        <Snackbar
          open={!!responseMessage}
          autoHideDuration={4000}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            severity={responseSeverity}
            onClose={handleCloseSnackbar}
            sx={{ width: "100%" }}
          >
            {responseMessage}
          </Alert>
        </Snackbar>
        <div style={{ padding: 8 }}>
          <div style={{ float: "left" }}>
            <span style={{ fontWeight: "bold", color: "#f44336" }}>
              {props.productErrorMessage}
            </span>
            {step === 1 && showSaveCharacteristicMessage && (
              <div style={{ color: "#f44336", fontSize: "12px" }}>
                {t("SAVE_APPL_CHARACTERISTIC_MESSAGE")}
              </div>
            )}
            {error.show && (
              <span style={{ fontWeight: "bold", color: "#f44336" }}>
                {/* {props.tabName}  */}

                {/* props.tabName reflects the currently selected tab or the last active tab before the "Show All Products" 
                                toggle was clicked. However, since we already have visibility into the selected tab, and in the case of 
                                "Show All Products," there’s a column displaying the category name, this makes props.tabName redundant. 
                                Therefore, it has been commented out. */}

                {error.key}
                {/* {t('IS_REQUIRED')} */}
              </span>
            )}
            {persistantError.show && (
              <span style={{ fontWeight: "bold", color: "#f44336" }}>
                {persistantError.key}
              </span>
            )}
            {customAttributeError.show && (
              <span style={{ fontWeight: "bold", color: "#f44336" }}>
                {t("CUSTOM_ATTRIBUTE")} {customAttributeError.error}
                {t("IS_REQUIRED")}
              </span>
            )}
            {err.variantDuplicateProductCodeError && (
              <div style={{ color: "red", marginBottom: "10px" }}>
                {err.variantDuplicateProductCodeError}
              </div>
            )}
          </div>
          {props.providerType === "SALES_CHNL_PROVIDER" ? (
            <div style={{ float: "right" }}>
              {props.addComponentType === "component" && !data.sellable && (
                <>
                  {step > 0 && (
                    // <Button onClick={event => changeStep(step === 3 ? 2 : step === 2 ? 1 : 0)} color="primary" style={{ marginLeft: 8 }}>{t('BACK')}</Button>
                    <Button
                      className="buttonSecondary"
                      onClick={(event) =>
                        changeStep(
                          step === 8
                            ? 7
                            : step === 7
                              ? 4
                              : step === 4
                                ? props.channelList.length > 0
                                  ? 3
                                  : customAttributesList.length > 0 ||
                                    checkCustomAttribute()
                                    ? 2
                                    : specificationAvailable
                                      ? 1
                                      : 0
                                : step === 3
                                  ? customAttributesList.length > 0 ||
                                    checkCustomAttribute()
                                    ? 2
                                    : specificationAvailable
                                      ? 1
                                      : 0
                                  : step === 2
                                    ? specificationAvailable
                                      ? 1
                                      : 0
                                    : step === 1
                                      ? 0
                                      : 0,
                        )
                      }
                      color="primary"
                      style={{ marginLeft: 8 }}
                    >
                      {t("BACK")}
                    </Button>
                  )}
                  {step === 0 && (
                    // <Button className='buttonSecondary' onClick={event => props.closeDialog()} color="primary" style={{ marginLeft: 8 }}>{readonlyMode ? t('CLOSE') : t('CANCEL')}</Button>
                    <Button
                      className="buttonSecondary"
                      onClick={(event) => handleCloseDialog()}
                      color="primary"
                    >
                      {readonlyMode ? t("CLOSE") : t("CANCEL")}
                    </Button>
                  )}
                  {step !== 8 && (
                    // <Button onClick={event => changeStep(step === 0 ? 1 : step === 1 ? 2 : 3)} color="primary" style={{ marginLeft: 8 }}>{t('NEXT')}</Button>
                    <Button
                      onClick={(event) =>
                        changeStep(
                          step === 0
                            ? specificationAvailable
                              ? 1
                              : customAttributesList.length > 0 ||
                                checkCustomAttribute()
                                ? 2
                                : props.channelList.length > 0
                                  ? 3
                                  : 4
                            : step === 1
                              ? customAttributesList.length > 0 ||
                                checkCustomAttribute()
                                ? 2
                                : props.channelList.length > 0
                                  ? 3
                                  : 4
                              : step === 2
                                ? props.channelList.length > 0
                                  ? 3
                                  : 4
                                : step === 3
                                  ? 4
                                  : step === 4
                                    ? 7
                                    : 8,
                        )
                      }
                      color="primary"
                      style={{ marginLeft: 8 }}
                    >
                      {t("NEXT")}
                    </Button>
                  )}
                  {step === 8 &&
                    (props.permissions.includes("CATALOG_ADMIN_ALL") ||
                      props.permissions.includes("CATALOG_CREATE") ||
                      props.permissions.includes("CATALOG_ADMIN")) &&
                    !readonlyMode &&
                    data.status != "P_PUBLISHED" && (
                      <>
                        {/*
                                        {!props.permissions.includes('CUMULATOR_PRODUCT_APPROVE') 
                                            && 
                                            <Button onClick={event => submitData('REVIEW')} color="primary" style={{ marginLeft: 8 }}>{t('REVIEW')}</Button>
                                        }
                                         */}
                        {/* {props.permissions.includes('CUMULATOR_PRODUCT_APPROVE') && */}
                        <>
                          <Button
                            onClick={(event) => submitData("PUBLISH")}
                            color="primary"
                            style={{ marginLeft: 8 }}
                          >
                            {t("PUBLISH")}
                          </Button>
                        </>
                        {/* } */}
                        {props.mode === "edit" ? (
                          <Button
                            onClick={(event) => submitData("UPDATE")}
                            color="primary"
                            style={{ marginLeft: 8 }}
                          >
                            {t("UPDATE")}
                          </Button>
                        ) : (
                          <Button
                            onClick={(event) => submitData("DRAFT")}
                            color="primary"
                            style={{ marginLeft: 8 }}
                          >
                            {t("SUBMIT")}
                          </Button>
                        )}
                      </>
                    )}
                </>
              )}
              {props.addComponentType === "component" && data.sellable && (
                <>
                  {step > 0 && (
                    // <Button onClick={event => changeStep(step === 5 ? 3 : step === 3 ? 2 : step === 2 ? 1 : 0)} color="primary" style={{ marginLeft: 8 }}>{t('BACK')}</Button>
                    <Button
                      className="buttonSecondary" /*onClick={event => {
                                            changeStep(
                                                step === 6 ? 5 : step === 5 ? 3 : step === 3 ? props.channelList.length > 0 ? 2 :
                                                    ((customAttributesList.length > 0) || checkCustomAttribute()) ? 1 : 0 : step === 2 ? 1 : 0);
                                            if (step === 5) {
                                                handleEditor();
                                            }
                                        }
                                        }*/
                      onClick={(event) => {
                        changeStep(
                          step === 8
                            ? 7
                            : step === 7
                              ? 6
                              : step === 6
                                ? 4
                                : step === 4
                                  ? props.channelList.length > 0
                                    ? 3
                                    : customAttributesList.length > 0 ||
                                      checkCustomAttribute()
                                      ? 2
                                      : specificationAvailable
                                        ? 1
                                        : 0
                                  : step === 3
                                    ? customAttributesList.length > 0 ||
                                      checkCustomAttribute()
                                      ? 2
                                      : specificationAvailable
                                        ? 1
                                        : 0
                                    : step === 2
                                      ? specificationAvailable
                                        ? 1
                                        : 0
                                      : step === 1
                                        ? 0
                                        : 0,
                        );
                        if (step === 6) {
                          handleEditor();
                        }
                      }}
                      color="primary"
                      style={{ marginLeft: 8 }}
                    >
                      {t("BACK")}
                    </Button>
                  )}
                  {step === 0 && (
                    // <Button className='buttonSecondary' onClick={event => props.closeDialog()} color="primary" style={{ marginLeft: 8 }}>{readonlyMode ? t('CLOSE') : t('CANCEL')}</Button>
                    <Button
                      className="buttonSecondary"
                      onClick={(event) => handleCloseDialog()}
                      color="primary"
                    >
                      {readonlyMode ? t("CLOSE") : t("CANCEL")}
                    </Button>
                  )}
                  {step !== 8 && (
                    // <Button onClick={event => changeStep(step === 0 ? 1 : step === 1 ? 2 : step === 2 ? 3 : 5)} color="primary" style={{ marginLeft: 8 }}>{t('NEXT')}</Button>
                    <Button
                      onClick={(event) => {
                        changeStep(
                          step === 0
                            ? specificationAvailable
                              ? 1
                              : customAttributesList.length > 0 ||
                                checkCustomAttribute()
                                ? 2
                                : props.channelList.length > 0
                                  ? 3
                                  : 4
                            : step === 1
                              ? customAttributesList.length > 0 ||
                                checkCustomAttribute()
                                ? 2
                                : props.channelList.length > 0
                                  ? 3
                                  : 4
                              : step === 2
                                ? props.channelList.length > 0
                                  ? 3
                                  : 4
                                : step === 3
                                  ? 4
                                  : step === 4
                                    ? 6
                                    : step === 6
                                      ? 7
                                      : 8,
                        );
                        if (step === 6) {
                          handleEditor();
                        }
                      }}
                      color="primary"
                      style={{ marginLeft: 8 }}
                    >
                      {t("NEXT")}
                    </Button>
                  )}
                  {step === 8 &&
                    (props.permissions.includes("CATALOG_ADMIN_ALL") ||
                      props.permissions.includes("CATALOG_CREATE") ||
                      props.permissions.includes("CATALOG_ADMIN")) &&
                    !readonlyMode &&
                    data.status != "P_PUBLISHED" && (
                      <>
                        <Button
                          onClick={(event) => submitData("PUBLISH")}
                          color="primary"
                          style={{ marginLeft: 8 }}
                        >
                          {t("PUBLISH")}
                        </Button>
                        <Button
                          onClick={(event) => submitData()}
                          color="primary"
                          style={{ marginLeft: 8 }}
                        >
                          {props.mode === "edit" ? t("UPDATE") : t("SUBMIT")}
                        </Button>
                      </>
                    )}
                </>
              )}
              {props.addComponentType === "assembly" && !data.sellable && (
                <>
                  {step > 0 && (
                    // <Button onClick={event => changeStep(step === 4 ? 3 : step === 3 ? 2 : step === 2 ? 1 : 0)} color="primary" style={{ marginLeft: 8 }}>{t('BACK')}</Button>
                    /*<Button className='buttonSecondary' onClick={event => changeStep(step === 7 ? 4 : step === 4 ? 3 : step === 3 ? props.channelList.length > 0 ? 2 :
                                            ((customAttributesList.length > 0) || checkCustomAttribute()) ? 1 : 0 : step === 2 ? ((customAttributesList.length > 0) || checkCustomAttribute()) ? 1 : 0 : 0)} color="primary" style={{ marginLeft: 8 }}>{t('BACK')}</Button>*/

                    <Button
                      className="buttonSecondary"
                      onClick={(event) =>
                        changeStep(
                          step === 8
                            ? 5
                            : step === 5
                              ? 4
                              : step === 4
                                ? props.channelList.length > 0
                                  ? 3
                                  : customAttributesList.length > 0 ||
                                    checkCustomAttribute()
                                    ? 2
                                    : specificationAvailable
                                      ? 1
                                      : 0
                                : step === 3
                                  ? customAttributesList.length > 0 ||
                                    checkCustomAttribute()
                                    ? 2
                                    : specificationAvailable
                                      ? 1
                                      : 0
                                  : step === 2
                                    ? specificationAvailable
                                      ? 1
                                      : 0
                                    : step === 1
                                      ? 0
                                      : 0,
                        )
                      }
                      color="primary"
                      style={{ marginLeft: 8 }}
                    >
                      {t("BACK")}
                    </Button>
                  )}
                  {step === 0 && (
                    // <Button className='buttonSecondary' onClick={event => props.closeDialog()} color="primary" style={{ marginLeft: 8 }}>{readonlyMode ? t('CLOSE') : t('CANCEL')}</Button>
                    <Button
                      className="buttonSecondary"
                      onClick={(event) => handleCloseDialog()}
                      color="primary"
                    >
                      {readonlyMode ? t("CLOSE") : t("CANCEL")}
                    </Button>
                  )}
                  {step !== 7 && (
                    // <Button onClick={event => changeStep(step === 0 ? 1 : step === 1 ? 2 : step === 2 ? 3 : 4)} color="primary" style={{ marginLeft: 8 }}>{t('NEXT')}</Button>
                    /*<Button onClick={event => changeStep(step === 0 ? ((customAttributesList.length > 0) || checkCustomAttribute()) ? 1 :
                                            props.channelList.length > 0 ? 2 : 3 : step === 1 ? props.channelList.length > 0 ? 2 : 3 : step === 2 ? 3 : step === 3 ? 4 : 6)} color="primary" style={{ marginLeft: 8 }}>{t('NEXT')}</Button>*/
                    <Button
                      onClick={(event) =>
                        changeStep(
                          step === 0
                            ? specificationAvailable
                              ? 1
                              : customAttributesList.length > 0 ||
                                checkCustomAttribute()
                                ? 2
                                : props.channelList.length > 0
                                  ? 3
                                  : 4
                            : step === 1
                              ? customAttributesList.length > 0 ||
                                checkCustomAttribute()
                                ? 2
                                : props.channelList.length > 0
                                  ? 3
                                  : 4
                              : step === 2
                                ? props.channelList.length > 0
                                  ? 3
                                  : 4
                                : step === 3
                                  ? 4
                                  : step === 4
                                    ? 5
                                    : 7,
                        )
                      }
                      color="primary"
                      style={{ marginLeft: 8 }}
                    >
                      {t("NEXT")}
                    </Button>
                  )}
                  {step === 8 &&
                    (props.permissions.includes("CATALOG_ADMIN_ALL") ||
                      props.permissions.includes("CATALOG_CREATE") ||
                      props.permissions.includes("CATALOG_ADMIN")) &&
                    !readonlyMode && (
                      <Button
                        onClick={(event) => submitData()}
                        color="primary"
                        style={{ marginLeft: 8 }}
                      >
                        {props.mode === "edit" ? t("UPDATE") : t("SUBMIT")}
                      </Button>
                    )}
                </>
              )}
              {props.addComponentType === "assembly" && data.sellable && (
                <>
                  {step > 0 && (
                    // <Button onClick={event => changeStep(step - 1)} color="primary" style={{ marginLeft: 8 }}>{t('BACK')}</Button>
                    /*<Button className='buttonSecondary' onClick={event => changeStep(step === 7 ? 5 : step === 5 ? 4 : step === 4 ? 3 : step === 3 ?
                                            props.channelList.length > 0 ? 2 : ((customAttributesList.length > 0) || checkCustomAttribute()) ? 1 : 0 : step === 2 ?
                                                ((customAttributesList.length > 0) || checkCustomAttribute()) ? 1 : 0 : 0)} color="primary" style={{ marginLeft: 8 }}>{t('BACK')}</Button>*/
                    <Button
                      className="buttonSecondary"
                      onClick={(event) =>
                        changeStep(
                          step === 8
                            ? 6
                            : step === 6
                              ? 5
                              : step === 5
                                ? 4
                                : step === 4
                                  ? props.channelList.length > 0
                                    ? 3
                                    : customAttributesList.length > 0 ||
                                      checkCustomAttribute()
                                      ? 2
                                      : specificationAvailable
                                        ? 1
                                        : 0
                                  : step === 3
                                    ? customAttributesList.length > 0 ||
                                      checkCustomAttribute()
                                      ? 2
                                      : specificationAvailable
                                        ? 1
                                        : 0
                                    : step === 2
                                      ? specificationAvailable
                                        ? 1
                                        : 0
                                      : step === 1
                                        ? 0
                                        : 0,
                        )
                      }
                      color="primary"
                      style={{ marginLeft: 8 }}
                    >
                      {t("BACK")}
                    </Button>
                  )}
                  {step === 0 && (
                    // <Button className='buttonSecondary' onClick={event => props.closeDialog()} color="primary" style={{ marginLeft: 8 }}>{readonlyMode ? t('CLOSE') : t('CANCEL')}</Button>
                    <Button
                      className="buttonSecondary"
                      onClick={(event) => handleCloseDialog()}
                      color="primary"
                    >
                      {readonlyMode ? t("CLOSE") : t("CANCEL")}
                    </Button>
                  )}
                  {step !== 7 && (
                    // <Button onClick={event => changeStep(step + 1)} color="primary" style={{ marginLeft: 8 }}>{t('NEXT')}</Button>
                    /*<Button onClick={event => changeStep(step === 0 ? ((customAttributesList.length > 0) || checkCustomAttribute()) ? 1 :
                                            props.channelList.length > 0 ? 2 : 3 : step === 1 ? props.channelList.length > 0 ? 2 : 3 :
                                            step === 2 ? 3 : step === 3 ? 4 : step === 4 ? 5 : 6)} color="primary" style={{ marginLeft: 8 }}>{t('NEXT')}</Button>*/
                    <Button
                      onClick={(event) =>
                        changeStep(
                          step === 0
                            ? specificationAvailable
                              ? 1
                              : customAttributesList.length > 0 ||
                                checkCustomAttribute()
                                ? 2
                                : props.channelList.length > 0
                                  ? 3
                                  : 4
                            : step === 1
                              ? customAttributesList.length > 0 ||
                                checkCustomAttribute()
                                ? 2
                                : props.channelList.length > 0
                                  ? 3
                                  : 4
                              : step === 2
                                ? props.channelList.length > 0
                                  ? 3
                                  : 4
                                : step === 3
                                  ? 4
                                  : step === 4
                                    ? 5
                                    : step === 5
                                      ? 6
                                      : 7,
                        )
                      }
                      color="primary"
                      style={{ marginLeft: 8 }}
                    >
                      {t("NEXT")}
                    </Button>
                  )}
                  {step === 8 &&
                    (props.permissions.includes("CATALOG_ADMIN_ALL") ||
                      props.permissions.includes("CATALOG_CREATE") ||
                      props.permissions.includes("CATALOG_ADMIN")) &&
                    !readonlyMode && (
                      <Button
                        onClick={(event) => submitData()}
                        color="primary"
                        style={{ marginLeft: 8 }}
                      >
                        {props.mode === "edit" ? t("UPDATE") : t("SUBMIT")}
                      </Button>
                    )}
                </>
              )}
            </div>
          ) : (
            <div style={{ float: "right" }}>
              {props.addComponentType === "component" && !data.sellable && (
                <>
                  {step > 0 && (
                    /*<Button className='buttonSecondary' onClick={event => changeStep(step === 7 ? 3 : step === 3 ? props.channelList.length > 0 ? 2 :
                                            ((customAttributesList.length > 0) || checkCustomAttribute()) ? 1 : 0 : step === 2 ? ((customAttributesList.length > 0) || checkCustomAttribute()) ? 1 : 0 : 0)} color="primary" style={{ marginLeft: 8 }}>{t('BACK')}</Button>*/
                    <Button
                      className="buttonSecondary"
                      onClick={(event) =>
                        changeStep(
                          step === 8
                            ? 4
                            : step === 4
                              ? props.channelList.length > 0
                                ? 3
                                : customAttributesList.length > 0 ||
                                  checkCustomAttribute()
                                  ? 2
                                  : specificationAvailable
                                    ? 1
                                    : 0
                              : step === 3
                                ? customAttributesList.length > 0 ||
                                  checkCustomAttribute()
                                  ? 2
                                  : specificationAvailable
                                    ? 1
                                    : 0
                                : step === 2
                                  ? specificationAvailable
                                    ? 1
                                    : 0
                                  : step === 1
                                    ? 0
                                    : 0,
                        )
                      }
                      color="primary"
                      style={{ marginLeft: 8 }}
                    >
                      {t("BACK")}
                    </Button>
                  )}
                  {step === 0 && (
                    // <Button className='buttonSecondary' onClick={event => props.closeDialog()} color="primary" style={{ marginLeft: 8 }}>{readonlyMode ? t('CLOSE') : t('CANCEL')}</Button>
                    <Button
                      className="buttonSecondary"
                      onClick={(event) => handleCloseDialog()}
                      color="primary"
                    >
                      {readonlyMode ? t("CLOSE") : t("CANCEL")}
                    </Button>
                  )}
                  {step !== 8 && (
                    // <Button onClick={event => changeStep(step === 0 ? 1 : step === 1 ? 2 : 3)} color="primary" style={{ marginLeft: 8 }}>{t('NEXT')}</Button>
                    /*<Button onClick={event => changeStep(
                                            step === 0 ?((customAttributesList.length > 0) || checkCustomAttribute()) ? 1  :
                                                        props.channelList.length > 0 ? 2 : 3 : step === 1 ? props.channelList.length > 0 ? 2 : 3 : 3
                                            )} color="primary" style={{ marginLeft: 8 }}>{t('NEXT')}</Button>*/
                    <Button
                      onClick={(event) =>
                        changeStep(
                          step === 0
                            ? 1
                            : step === 1
                              ? customAttributesList.length > 0 ||
                                checkCustomAttribute()
                                ? 2
                                : props.channelList.length > 0
                                  ? 3
                                  : 4
                              : step === 2
                                ? props.channelList.length > 0
                                  ? 3
                                  : 4
                                : 4
                                  ? 8
                                  : 8,
                        )
                      }
                      color="primary"
                      style={{ marginLeft: 8 }}
                    >
                      {t("NEXT")}
                    </Button>
                  )}
                  {step === 8 &&
                    (props.permissions.includes("CATALOG_ADMIN_ALL") ||
                      props.permissions.includes("CATALOG_CREATE") ||
                      props.permissions.includes("CATALOG_ADMIN")) &&
                    !readonlyMode &&
                    data.status != "P_PUBLISHED" && (
                      <>
                        <Button
                          onClick={(event) => submitData()}
                          color="primary"
                          style={{ marginLeft: 8 }}
                        >
                          {props.mode === "edit" ? t("UPDATE") : t("SUBMIT")}
                        </Button>

                        {props.permissions.includes(
                          "CUMULATOR_PRODUCT_APPROVE",
                        ) && (
                            <Button
                              onClick={(event) => submitData("PUBLISH")}
                              color="primary"
                              style={{ marginLeft: 8 }}
                            >
                              {t("PUBLISH")}
                            </Button>
                          )}
                      </>
                    )}
                </>
              )}
              {props.addComponentType === "component" && data.sellable && (
                <>
                  {step > 0 && (
                    // <Button onClick={event => changeStep(step === 5 ? 3 : step === 3 ? 2 : step === 2 ? 1 : 0)} color="primary" style={{ marginLeft: 8 }}>{t('BACK')}</Button>
                    <Button
                      className="buttonSecondary"
                      onClick={(event) => {
                        changeStep(
                          step === 7
                            ? 6
                            : step === 6
                              ? 4
                              : step === 4
                                ? props.channelList.length > 0
                                  ? 3
                                  : customAttributesList.length > 0 ||
                                    checkCustomAttribute()
                                    ? 2
                                    : specificationAvailable
                                      ? 1
                                      : 0
                                : step === 3
                                  ? customAttributesList.length > 0 ||
                                    checkCustomAttribute()
                                    ? 2
                                    : specificationAvailable
                                      ? 1
                                      : 0
                                  : step === 2
                                    ? specificationAvailable
                                      ? 1
                                      : 0
                                    : step === 1
                                      ? 0
                                      : 0,
                        );
                        if (step === 6) {
                          handleEditor();
                        }
                      }}
                      color="primary"
                      style={{ marginLeft: 8 }}
                    >
                      {t("BACK")}
                    </Button>
                  )}
                  {step === 0 && (
                    // <Button className='buttonSecondary' onClick={event => props.closeDialog()} color="primary" style={{ marginLeft: 8 }}>{readonlyMode ? t('CLOSE') : t('CANCEL')}</Button>
                    <Button
                      className="buttonSecondary"
                      onClick={(event) => handleCloseDialog()}
                      color="primary"
                    >
                      {readonlyMode ? t("CLOSE") : t("CANCEL")}
                    </Button>
                  )}
                  {step !== 7 && (
                    // <Button onClick={event => changeStep(step === 0 ? 1 : step === 1 ? 2 : step === 2 ? 3 : 5)} color="primary" style={{ marginLeft: 8 }}>{t('NEXT')}</Button>
                    <Button
                      onClick={(event) => {
                        changeStep(
                          step === 0
                            ? specificationAvailable
                              ? 1
                              : customAttributesList.length > 0 ||
                                checkCustomAttribute()
                                ? 2
                                : props.channelList.length > 0
                                  ? 3
                                  : 4
                            : step === 1
                              ? customAttributesList.length > 0 ||
                                checkCustomAttribute()
                                ? 2
                                : props.channelList.length > 0
                                  ? 3
                                  : 4
                              : step === 2
                                ? props.channelList.length > 0
                                  ? 3
                                  : 4
                                : step === 3
                                  ? 4
                                  : step === 4
                                    ? 6
                                    : 7,
                        );
                        if (step === 6) {
                          handleEditor();
                        }
                      }}
                      color="primary"
                      style={{ marginLeft: 8 }}
                    >
                      {t("NEXT")}
                    </Button>
                  )}
                  {step === 7 &&
                    (props.permissions.includes("CATALOG_ADMIN_ALL") ||
                      props.permissions.includes("CATALOG_CREATE") ||
                      props.permissions.includes("CATALOG_ADMIN")) &&
                    !readonlyMode && (
                      <Button
                        onClick={(event) => {
                          submitData();
                        }}
                        color="primary"
                        style={{ marginLeft: 8 }}
                      >
                        {props.mode === "edit" ? t("UPDATE") : t("SUBMIT")}
                      </Button>
                    )}
                </>
              )}
              {props.addComponentType === "assembly" && !data.sellable && (
                <>
                  {step > 0 && (
                    // <Button onClick={event => changeStep(step === 4 ? 3 : step === 3 ? 2 : step === 2 ? 1 : 0)} color="primary" style={{ marginLeft: 8 }}>{t('BACK')}</Button>
                    <Button
                      className="buttonSecondary"
                      onClick={(event) =>
                        changeStep(
                          step === 7
                            ? 5
                            : step === 5
                              ? 4
                              : step === 4
                                ? props.channelList.length > 0
                                  ? 3
                                  : customAttributesList.length > 0 ||
                                    checkCustomAttribute()
                                    ? 2
                                    : specificationAvailable
                                      ? 1
                                      : 0
                                : step === 3
                                  ? customAttributesList.length > 0 ||
                                    checkCustomAttribute()
                                    ? 2
                                    : specificationAvailable
                                      ? 1
                                      : 0
                                  : step === 2
                                    ? specificationAvailable
                                      ? 1
                                      : 0
                                    : step === 1
                                      ? 0
                                      : 0,
                        )
                      }
                      color="primary"
                      style={{ marginLeft: 8 }}
                    >
                      {t("BACK")}
                    </Button>
                  )}
                  {step === 0 && (
                    // <Button className='buttonSecondary' onClick={event => props.closeDialog()} color="primary" style={{ marginLeft: 8 }}>{readonlyMode ? t('CLOSE') : t('CANCEL')}</Button>
                    <Button
                      className="buttonSecondary"
                      onClick={(event) => handleCloseDialog()}
                      color="primary"
                    >
                      {readonlyMode ? t("CLOSE") : t("CANCEL")}
                    </Button>
                  )}
                  {step !== 5 && (
                    // <Button onClick={event => changeStep(step === 0 ? 1 : step === 1 ? 2 : step === 2 ? 3 : 4)} color="primary" style={{ marginLeft: 8 }}>{t('NEXT')}</Button>
                    <Button
                      onClick={(event) =>
                        changeStep(
                          step === 0
                            ? specificationAvailable
                              ? 1
                              : customAttributesList.length > 0 ||
                                checkCustomAttribute()
                                ? 2
                                : props.channelList.length > 0
                                  ? 3
                                  : 4
                            : step === 1
                              ? customAttributesList.length > 0 ||
                                checkCustomAttribute()
                                ? 2
                                : props.channelList.length > 0
                                  ? 3
                                  : 4
                              : step === 2
                                ? props.channelList.length > 0
                                  ? 3
                                  : 4
                                : step === 3
                                  ? 4
                                  : 5,
                        )
                      }
                      color="primary"
                      style={{ marginLeft: 8 }}
                    >
                      {t("NEXT")}
                    </Button>
                  )}
                  {step === 5 &&
                    (props.permissions.includes("CATALOG_ADMIN_ALL") ||
                      props.permissions.includes("CATALOG_CREATE") ||
                      props.permissions.includes("CATALOG_ADMIN")) &&
                    !readonlyMode && (
                      <Button
                        onClick={(event) => submitData()}
                        color="primary"
                        style={{ marginLeft: 8 }}
                      >
                        {props.mode === "edit" ? t("UPDATE") : t("SUBMIT")}
                      </Button>
                    )}
                </>
              )}
              {props.addComponentType === "assembly" && data.sellable && (
                <>
                  {step > 0 && (
                    // <Button onClick={event => changeStep(step - 1)} color="primary" style={{ marginLeft: 8 }}>{t('BACK')}</Button>
                    <Button
                      className="buttonSecondary"
                      onClick={(event) =>
                        changeStep(
                          step === 7
                            ? 6
                            : step === 6
                              ? 5
                              : step === 5
                                ? 4
                                : step === 4
                                  ? props.channelList.length > 0
                                    ? 3
                                    : customAttributesList.length > 0 ||
                                      checkCustomAttribute()
                                      ? 2
                                      : specificationAvailable
                                        ? 1
                                        : 0
                                  : step === 3
                                    ? customAttributesList.length > 0 ||
                                      checkCustomAttribute()
                                      ? 2
                                      : specificationAvailable
                                        ? 1
                                        : 0
                                    : step === 2
                                      ? specificationAvailable
                                        ? 1
                                        : 0
                                      : step === 1
                                        ? 0
                                        : 0,
                        )
                      }
                      color="primary"
                      style={{ marginLeft: 8 }}
                    >
                      {t("BACK")}
                    </Button>
                  )}
                  {step === 0 && (
                    // <Button className='buttonSecondary' onClick={event => props.closeDialog()} color="primary" style={{ marginLeft: 8 }}>{readonlyMode ? t('CLOSE') : t('CANCEL')}</Button>
                    <Button
                      className="buttonSecondary"
                      onClick={(event) => handleCloseDialog()}
                      color="primary"
                    >
                      {readonlyMode ? t("CLOSE") : t("CANCEL")}
                    </Button>
                  )}
                  {step !== 6 && (
                    // <Button onClick={event => changeStep(step + 1)} color="primary" style={{ marginLeft: 8 }}>{t('NEXT')}</Button>
                    <Button
                      onClick={(event) =>
                        changeStep(
                          step === 0
                            ? specificationAvailable
                              ? 1
                              : customAttributesList.length > 0 ||
                                checkCustomAttribute()
                                ? 2
                                : props.channelList.length > 0
                                  ? 3
                                  : 4
                            : step === 1
                              ? customAttributesList.length > 0 ||
                                checkCustomAttribute()
                                ? 2
                                : props.channelList.length > 0
                                  ? 3
                                  : 4
                              : step === 2
                                ? props.channelList.length > 0
                                  ? 3
                                  : 4
                                : step === 3
                                  ? 4
                                  : step === 4
                                    ? 5
                                    : 6,
                        )
                      }
                      color="primary"
                      style={{ marginLeft: 8 }}
                    >
                      {t("NEXT")}
                    </Button>
                  )}
                  {step === 6 &&
                    (props.permissions.includes("CATALOG_ADMIN_ALL") ||
                      props.permissions.includes("CATALOG_CREATE") ||
                      props.permissions.includes("CATALOG_ADMIN")) &&
                    !readonlyMode && (
                      <Button
                        onClick={(event) => submitData()}
                        color="primary"
                        style={{ marginLeft: 8 }}
                      >
                        {props.mode === "edit" ? t("UPDATE") : t("SUBMIT")}
                      </Button>
                    )}
                </>
              )}
            </div>
          )}
          <div style={{ clear: "both" }}></div>
        </div>
        {showCustomerDialog && (
          <Dialog
            disableScrollLock={true}
            maxWidth={"md"}
            fullWidth={true}
            open={showCustomerDialog}
            aria-labelledby="importKitPaper"
            PaperComponent={ImportKitPaper}
          // PaperProps={{
          //     className: classess.resizablePaper
          // }}
          >
            <DialogTitle id="importKitPaper" style={{ cursor: "move" }}>
              {/* {t('SELECT_CUSTOMERS')} */}
              <div style={{ display: "flex" }}>
                <span style={{ display: "inline-flex", width: "100%" }}>
                  {t("SELECT_CUSTOMERS")}
                </span>
                <Tooltip title={t("CLOSE")}>
                  <IconButton
                    onTouchStart={(event) => setShowCustomerDialog(false)}
                    onClick={(event) => setShowCustomerDialog(false)}
                    aria-label="close"
                  >
                    <CloseIcon />
                  </IconButton>
                </Tooltip>
              </div>
            </DialogTitle>
            <DialogContent dividers style={{ height: "550px" }}>
              <ManageCustomersHierarchy
                screen="products"
                subScreen="product"
                selectCustomers={selectCustomers}
                customerData={customersList}
                preSelectedCustomer={props.selectedCustomer}
              />
            </DialogContent>
            <DialogActions>
              <Button
                onClick={(event) => setShowCustomerDialog(false)}
                color="primary"
              >
                {t("ADD_SELECTED_CUSTOMERS")}
              </Button>
            </DialogActions>
          </Dialog>
        )}
      </Dialog>
      <UnsavedChangesWarning
        open={openUnsavedChangesModal}
        close={confirmCloseDialog}
      />
    </>
  );
};

const CreateProductPaper = (props) => {
  const nodeRef = useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      bounds={"parent"}
      defaultClassName="customReactDraggableComponent"
      handle="#createProductTitle"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper ref={nodeRef} {...props} />
    </Draggable>
  );
};

const ImportKitPaper = (props) => {
  const nodeRef = useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      bounds={"parent"}
      defaultClassName="customReactDraggableComponent"
      handle="#importKitPaper"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper ref={nodeRef} {...props} />
    </Draggable>
  );
};

const mapStateToProps = (state) => {
  return {
    enabledModules: state.auth.enabledModules,
    permissions: state.auth.userPerms,
    menuPaths: state.auth.menuPaths,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(withNavigation(ComponentDialog)));
